<script setup>
import { computed, onMounted, ref, inject, nextTick, getCurrentInstance } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiEye, mdiTrashCan, mdiPencil, mdiCheckDecagram, mdiCalendarClock, mdiBook, mdiContentSave, mdiPlusBox,
    mdiInformationOutline, mdiPlusCircle, mdiDotsVertical, mdiChevronLeft, mdiChevronRight,
    mdiDownload, mdiArrowUpCircle, mdiArrowDownCircle, mdiAccountGroup, mdiNoteText, mdiHandWave, mdiArrowLeftTopBold,
    mdiCheckBold, mdiExclamationThick, mdiCloseThick, mdiAccountBox, mdiCloseCircle, mdiCheckCircle, mdiRefresh, mdiContrastCircle, mdiAlertCircle, mdiMenu, mdiPaperclip, mdiAccountVoice, mdiAccountMultiple, mdiPlusThick, mdiPlus, mdiArrowULeftTopBold, mdiBookEdit, mdiBookOpenVariant, mdiNewBox, mdiNewspaper, mdiCloudUploadOutline, mdiTagCheck, mdiPresentation
} from "@mdi/js";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeLabel from '@/Components/Label.vue';
import BreezeInput from '@/Components/Input.vue';
import { QuillEditor } from '@vueup/vue-quill'
//import BlotFormatter from 'quill-blot-formatter'
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import TableResponsive from "@/Components/TableResponsive.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import ClassroomTopicManager from "@/Components/ClassroomTopicManager.vue";
import NotificationBar from "@/Components/NotificationBar.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import Buttons from "@/Components/Buttons.vue";
import PremiumPageHeader from "@/Components/PremiumPageHeader.vue";
import PremiumTabs from '@/Components/PremiumTabs.vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BreezeDropdownOption from '@/Components/DropdownOption.vue';
import { useGradesExport } from '@/Common/useGradesExport.js';
import ModalAlert from "@/Components/ModalAlert.vue";
import { Icon } from '@iconify/vue';

// LRR
const props = defineProps({
    titleup: String,
    classroom: Object,
    course: Object,
    level_course: Object,
    guides: Array,
    asesorias: Array,
    motivaciones: Array,
    anuncios: Array,
    temas: Array,
    resources: Array,
    resourceLinks: Array,
    students: Array,
    studentCol: Array,
    diarios: Array,
    nowDate: String,
    nowDateFormated: String,
    nowDay: String,
    nowMonthLetter: String,
    nowDayLetter: String,
    //message: String,
    tasks: Array,
    refCicloActual: String,
    bimestreActual: String,
    semanaActual: Number,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    isTutor: Boolean,
    isMaster: Boolean,
    isCoord: Boolean,
    isAdmin: Boolean,
    showPreviewGuide: Boolean,
    anioEscolar: String,
    back_link: String,
    closeB1: Boolean,
    closeB2: Boolean,
    closeB3: Boolean,
    closeB4: Boolean,
    existParcial2B1: Boolean,
    existParcial2B2: Boolean,
    existParcial2B3: Boolean,
    existParcial2B4: Boolean,
    debugInertia: Boolean,
    ciclos: Array
});

// Editar tamaño de imagen en QuillEditor
//const modulesEditor = {
//name: 'blotFormatter',  
//module: BlotFormatter, 
//options: {/* options */}
//}

//console.log(props.debugInertia)
//console.log('Hola')
//confGlobal.value.ACTUALIZAR_ACCESO_ALUMNO_FILE_BANCO
//const myGlobalVariable = inject(confGlobal.value)
//console.log(myGlobalVariable)
//console.log(this.constGlobal)

const responseMsg = ref(null);
const arrayCalifications = ref([])
const taskResponses = ref([])

const modalAlertState = ref({
    show: false,
    title: '',
    message: '',
    type: 'info',
    icon: '',
    showCloseButton: false,
    closeButtonText: 'Cerrar',
    closeButtonColor: 'gray'
});
onMounted(() => {
    //listarCalification(props.refCicloActual) <-- Ya no listar por defecto
    langs()
    declareRows('temas')
    getPostit()
    listarTaskResponses()// <-- Por defecto id_task = 0
    //console.log(taskResponses.value)
    loadAgendaRecordsForCourse()
});

/* onMounted(() => {
    langs();
}); */

const data = {
    "estudiante_curso": [
        { "id": 1, "codigo": "2205-ARTE", "name": "ARTE", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 2, "codigo": "2205-BIOLO", "name": "BIOLOGIA", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "última fecha de entrega de trabajos este viernes ..." },
        { "id": 3, "codigo": "2205-FISICA", "name": "FISICA", "tarea": "2/2 (FL 12/10/2022)", "anuncio": "Entrega de trabajo grupal hasta el martes" },
        { "id": 4, "codigo": "2205-QUIMICA", "name": "QUIMICA", "tarea": "4/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 5, "codigo": "2205-HISTO", "name": "HISTORIA DEL PERU", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
    ]
};

let myRadios = document.getElementsByName('tabs2');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}

/* const filesForLevel = ref([])
onMounted(() => {
    let url = '/file/listfilesforlevel';
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        filesForLevel.value = respuesta.files;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    });
}); */

const showLog = ref(false);
const isModalActive = ref(false);
const isModalDangerActive = ref(false);
const isModalFullActive = ref(false);
const modalSize = ref('preview')
const modalFullSrc = ref('');
const refCiclo = ref('')/// <------------------- Revisar
const rowID = ref('');
const rowParentID = ref('');
const rowAction = ref('');
const isErrorForm = ref(false)
const titleModal = ref('')
const subTextModal = ref('este registro?')
const errorMessage = ref('')


const refCicloSelect = ref('')

const tabCalif = ref(-1)
// Desactivar el inicio de listado
/* if (props.refCicloActual.indexOf('B2')) {
    tabCalif.value = 1
} else if (props.refCicloActual.filter('B3')) {
    tabCalif.value = 2;
} else if (props.refCicloActual.filter('B4')) {
    tabCalif.value = 3;
} */

// Cargar vista modal Full para vista previa
const srcParamOnlyRead = ref('')
const showVistaPrevia = (ruta = '', option = '', size = 'preview') => {
    isModalFullActive.value = true
    modalFullSrc.value = ruta
    modalSize.value = size

    if (option == 'onlyread') {
        srcParamOnlyRead.value = '#toolbar=0' // <-- ocultar toolbar y a futuro ocultar context menu :oncontextmenu
    } else {
        srcParamOnlyRead.value = ''
    }

}

const formTarea = useForm({
    id_classroom: props.classroom.id,
    id_course: props.course.id,
    ref_ciclo: props.refCicloActual,//refCiclo.value,// Se busca por ref pues son 4 2023B1, 2023B2, 2023B3, 2023B4
    label: '',
    description: '',
    start_date: null,
    end_date: null,
    delivery_type: 'digital',
    is_graded: 1,
    status: 0,

    description_collaborator: '',
    calification: 0,
    id_task: 0
});

const formLink = useForm({
    id_classroom: props.classroom.id,
    id_course: props.course.id,
    //ref_ciclo: props.refCicloActual,//refCiclo.value,// Se busca por ref pues son 4 2023B1, 2023B2, 2023B3, 2023B4
    label: '',
    description: '',
    url: ''
});

const registrarLink = () => {
    let ruta = 'link-registrar'
    axios.post(route(ruta), {
        'object_type': 'resourceCourseClass',
        'object_id': formLink.id_classroom,
        'object_id2': formLink.id_course,
        'label': formLink.label,
        'description': formLink.description,
        'url': formLink.url
    }).then((response) => {
        if (!props.debugInertia) Inertia.reload({ only: ['resourceLinks'] })
        cleanVal()
        cleanInputFile()

        console.log(error)
    }).catch((error) => {
        console.log(error)
    });
}

const existeAdjunto = ref(false)
const filePath = ref('')
const fileName = ref('')

const initModal = (id, action, data = []) => {
    isErrorForm.value = false
    rowAction.value = action
    titleModal.value = action
    if (action == 'borrador') {
        titleModal.value = 'establecer como borrador'
    } else if (action == 'leer') {
        titleModal.value = 'vista previa de la tarea'
    } else if (action == 'tarearesponse-actualizarresp') {
        titleModal.value = 'Nota y/o comentarios a la respuesta de la tarea'
    } else if (action == 'tarearesponse-actualizarresp-adjunto') {
        titleModal.value = 'Nota y/o comentarios a la respuesta de la tarea'
    } else if (action == 'tarearesponse-borrador') {
        titleModal.value = 'establecer como borrador'
    } else if (action == 'deleteFile') {
        titleModal.value = 'eliminar'
    } else if (action == 'deleteFileTask') {
        titleModal.value = 'eliminar archivo adjunto'
        subTextModal.value = 'de esta tarea?'
    } else if (action == 'actualizarFile') {
        titleModal.value = 'actualizar recurso'
    } else if (action == 'deleteTask') {
        titleModal.value = 'eliminar'
        subTextModal.value = 'esta tarea?'
    } else if (action == 'actualizarLink') {
        titleModal.value = 'actualizar'
        subTextModal.value = 'este link?'
    } else if (action == 'deleteLink') {
        titleModal.value = 'eliminar'
    }

    if (action == 'registrar') {
        isModalActive.value = true
        formTarea.delivery_type = 'digital'
        formTarea.is_graded = 1
        formTarea.label = ''
        formTarea.description = ''
        formTarea.end_date = null
        if (fileTask.value) fileTask.value.value = ''

    } else if (action == 'actualizar') {
        rowID.value = id;
        isModalActive.value = true
        formTarea.ref_ciclo = data['ref_ciclo']
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.start_date = data['start_date']
        formTarea.end_date = data['end_date']
        formTarea.status = data['status']
        formTarea.delivery_type = data['delivery_type'] || 'digital'
        formTarea.is_graded = data['is_graded'] !== undefined ? (data['is_graded'] ? 1 : 0) : 1
        if (fileTask.value) fileTask.value.value = ''
        if (data['id_file']) {
            existeAdjunto.value = true
            filePath.value = data['filepath']
            fileName.value = data['filename']
            modalFullSrc.value = '/documents/' + data['filepath'] + '/' + data['filename']
            console.log(filePath.value + ' - ' + fileName.value)
        }

    } else if (action == 'tarearesponse-actualizarresp') {
        rowID.value = id;
        isModalActive.value = true
        formTarea.ref_ciclo = data['ref_ciclo']
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.start_date = data['start_date']
        formTarea.end_date = data['end_date']
        formTarea.status = data['status']

        formTarea.description_collaborator = data['description_collaborator']
        formTarea.calification = data['calification']
        formTarea.id_task = data['id_task']
        rowParentID.value = data['id_task']

    } else if (action == 'tarearesponse-actualizarresp-adjunto') {
        rowID.value = id;
        isModalFormFullActive.value = true
        formTarea.ref_ciclo = data['ref_ciclo']
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.start_date = data['start_date']
        formTarea.end_date = data['end_date']
        formTarea.status = data['status']
        if (data['id_file']) {
            existeAdjunto.value = true
            filePath.value = data['filepath']
            fileName.value = data['filename']
            modalFullSrc.value = '/documents/' + data['filepath'] + '/' + data['filename']
            console.log(filePath.value + ' - ' + fileName.value)
        }

        formTarea.description_collaborator = data['description_collaborator']
        formTarea.calification = data['calification']
        formTarea.id_task = data['id_task']
        rowParentID.value = data['id_task']

    } else if (action == 'tarearesponse-leerresp-adjunto') {
        rowID.value = id;
        isModalFormFullActive.value = true
        formTarea.ref_ciclo = data['ref_ciclo']
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.start_date = data['start_date']
        formTarea.end_date = data['end_date']
        formTarea.status = data['status']
        if (data['id_file']) {
            existeAdjunto.value = true
            filePath.value = data['filepath']
            fileName.value = data['filename']
            modalFullSrc.value = '/documents/' + data['filepath'] + '/' + data['filename']
            console.log(filePath.value + ' - ' + fileName.value)
        }

        formTarea.description_collaborator = data['description_collaborator']
        formTarea.calification = data['calification']
        formTarea.id_task = data['id_task']
        rowParentID.value = data['id_task']

    } else if (action == 'leer') {
        rowID.value = id;
        isModalActive.value = true
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.start_date = data['start_date']
        formTarea.end_date = data['end_date']
        formTarea.status = data['status']

    } else if (action == 'leer-respuesta') {
        rowID.value = id;
        isModalActive.value = true
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.start_date = data['start_date']
        formTarea.end_date = data['end_date']
        formTarea.status = data['status']
        formTarea.description_collaborator = data['description_collaborator']
        formTarea.calification = data['calification']

    } else if (action == 'tarearesponse-borrador') {
        rowID.value = id;
        rowParentID.value = data['id_task']
        isModalDangerActive.value = true

    } else if (action == 'actualizarFile') {
        rowID.value = id;
        //rowParentID.value = data['id_task']
        isModalActive.value = true
        formFile.name = data['name']
        formFile.description = data['description']
        formFile.position = data['position']

    } else if (action == 'actualizarLink') {
        rowID.value = id;
        //rowParentID.value = data['id_task']
        isModalActive.value = true
        formLink.url = data['url']
        formLink.label = data['label']
        formLink.description = data['description']

    } else {// Casos de publicar o no
        rowID.value = id;
        isModalDangerActive.value = true

    }
}

const isConfirm = () => {
    //alert('Hola '+rowID.value+'modal es '+rowAction.value)
    ///let ruta = props.ruta + '-' + rowAction.value
    let ruta = 'tarea-' + rowAction.value
    if (rowAction.value == 'tarearesponse-borrador') {
        ruta = rowAction.value
    } else if (rowAction.value == 'tarearesponse-actualizarresp' || rowAction.value == 'tarearesponse-actualizarresp-adjunto') {
        ruta = 'tarearesponse-actualizarresp'
    }

    if (rowAction.value == 'registrar') {

        if (!formTarea.label || !formTarea.ref_ciclo) {
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.post(route(ruta, {
                'id_classroom': formTarea.id_classroom,
                'id_course': formTarea.id_course,
                'ref_ciclo': formTarea.ref_ciclo,
                'label': formTarea.label,
                'description': formTarea.description || '',
                'start_date': formTarea.start_date,
                'end_date': formTarea.end_date,
                'delivery_type': formTarea.delivery_type || 'digital',
                'is_graded': formTarea.is_graded ? 1 : 0
            })).then(async (response) => {
                const newTaskId = response.data?.task?.id || response.data?.id
                if (newTaskId && fileTask.value?.files?.[0]) {
                    inputFileName.value = 'TAREA' + newTaskId
                    await uploadFile('file_task', newTaskId)
                }
                cleanVal()
                isModalActive.value = false
                if (!props.debugInertia) Inertia.reload({ only: ['tasks'] })
            }).catch((error) => {
                console.log(error)
            })
        }

    } else if (rowAction.value == 'actualizar') {

        if (!formTarea.label || !formTarea.ref_ciclo) {
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.put(route(ruta, {
                'id': rowID.value,
                'ref_ciclo': formTarea.ref_ciclo,
                'label': formTarea.label,
                'description': formTarea.description || '',
                'start_date': formTarea.start_date,
                'end_date': formTarea.end_date,
                'delivery_type': formTarea.delivery_type || 'digital',
                'is_graded': formTarea.is_graded ? 1 : 0
            })).then(async (response) => {
                if (fileTask.value?.files?.[0]) {
                    inputFileName.value = 'TAREA' + rowID.value
                    await uploadFile('file_task', rowID.value)
                }
                cleanVal()
                isModalActive.value = false
                if (!props.debugInertia) Inertia.reload({ only: ['tasks'] })
            }).catch((error) => { console.log(error) })

        }

    } else if (rowAction.value == 'actualizarFile') {
        ruta = 'file-actualizar'
        if (!formFile.name || !formFile.position) {
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.post(route(ruta, { // <-- put recurso ahora es post
                'id': rowID.value,
                'name': formFile.name,
                'description': formFile.description,
                'position': formFile.position
            })).then((response) => {
                console.log(response)
                console.log('Recurso actualizado')
                cleanVal()
                cleanInputFile()
                if (!props.debugInertia) Inertia.reload({ only: ['resources'] })
            }).catch((error) => { console.log(error) })
        }

    } else if (rowAction.value == 'actualizarLink') {
        ruta = 'link-actualizar'
        if (!formLink.label || !formLink.url) {
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.put(route(ruta, {
                'id': rowID.value,
                'url': formLink.url,
                'label': formLink.label,
                'description': formLink.description,
            })).then((response) => {
                console.log(response)
                console.log('Recurso Link actualizado')
                cleanVal()
                cleanInputFile()
                if (!props.debugInertia) Inertia.reload({ only: ['resourceLinks'] })
            }).catch((error) => { console.log(error) })
        }

    } else if (rowAction.value == 'tarearesponse-actualizarresp' || rowAction.value == 'tarearesponse-actualizarresp-adjunto') {

        if (!formTarea.calification) {
            isErrorForm.value = true
            if (rowAction.value == 'tarearesponse-actualizarresp-adjunto') {
                isModalFormFullActive.value = true
            } else {
                isModalActive.value = true
            }

        } else {
            axios.put(route(ruta, {
                'id': rowID.value,
                //'ref_ciclo' : formTarea.ref_ciclo,
                //'label' : formTarea.label,
                'description_collaborator': formTarea.description_collaborator,
                'calification': formTarea.calification
            })).then((response) => {
                console.log(response)
                console.log('Respuesta a la respuesta actualizada')
                listarTaskResponses()
                if (!props.debugInertia) Inertia.reload({ only: ['tasks'] })// para que no aparesca la pantalla
                cleanVal()
                isModalFormFullActive.value = false
            }).catch((error) => { console.log(error) })

        }

    } else if (rowAction.value == 'deleteLink') {
        ruta = 'link-eliminar'
        axios.post(route(ruta), {
            'id': rowID.value
        }).then((response) => {
            console.log('Recurso Link eliminado')
            cleanVal()
            cleanInputFile()
            if (!props.debugInertia) Inertia.reload({ only: ['resourceLinks'] })
        }).catch((error) => {
            console.log(error);
        })

    } else {
        // Borrado o publicar
        if (rowAction.value == 'deleteFile') {
            deleteFile(rowID.value, 'file_resource')
        } else if (rowAction.value == 'deleteFileTask') {
            deleteFile(rowID.value, 'file_task')
        } else {
            axios.put(route(ruta, {
                'id': rowID.value,
            })).then((response) => {
                console.log(response)
                console.log('Action: ' + rowAction.value)
                cleanVal()
                listarTaskResponses()
                if (!props.debugInertia) Inertia.reload({ only: ['tasks'] })
            }).catch((error) => { console.log(error) })

        }

    }

}

const isCancel = () => {

    cleanVal()
    cleanInputFile()
}

const refreshList = (action = []) => {
    /* if (action == 'asistencias') {
        Inertia.reload({ only: ['asistencia']})
    } else if (action == 'tareas') {
        Inertia.reload({ only: ['tasks']})
    } */
    if (!props.debugInertia) Inertia.reload({ only: action })
    if (action.includes('taskResponses')) {
        listarTaskResponses()// <-- Por defecto id_task = 0
    }
    console.log('Refresh')
}

const tareaEditor = ref(null)// <-- Para limpiar contenido de editor
const cleanEditor = ref(true)

const cleanVal = (cleanEditor = 1) => {

    rowID.value = 0;
    rowAction.value = ''
    //modalFullSrc.value = '' // <-- Al editar tarea o al cancelar modal ya no se podía ver la vista previa
    titleModal.value = ''
    rowParentID.value = ''

    existeAdjunto.value = false
    filePath.value = ''
    fileName.value = ''
    errorMessage.value = ''
    subTextModal.value = 'este registro?'

    // Tarea
    if (cleanEditor) {// <-- No borrar si cierro el editor en nueva edición
        formTarea.label = ''
        formTarea.description = ''
        formTarea.start_date = null
        formTarea.end_date = null
        formTarea.delivery_type = 'digital'
        formTarea.is_graded = 1
        formTarea.status = 0
        if (fileTask.value) fileTask.value.value = ''
        tareaEditor.value.setContents('')// <-- Limpiar contenido de texto enriquecido

        formTarea.description_collaborator = ''
        formTarea.calification = 0
    }
}

// Diario
const arrayDiario = ref([]);
const formDiario = useForm({
    id_student: 0,
    //id_course: props.course.id,
    id_classroom: props.classroom.id,
    ref_ciclo: props.refCicloActual,
    fecha: props.nowDate,
    asistencia: 1,
    //title: props.course.label + ' (A)',
    title: '(A)',
    content: '',

    percent: -1

});

const iniciarAsistencia = () => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
      } */

    const newArr = [];
    const arr = props.students
    arr.forEach((student) => {

        newArr.push({
            id_student: student.id,
            //id_course: formDiario.id_course,
            id_classroom: formDiario.id_classroom,
            asistencia: formDiario.asistencia,
            title: formDiario.title,
            content: formDiario.content,
            fecha: formDiario.fecha,
            percent: formDiario.percent
        });

    });
    let ruta = 'diario-registrar'
    if (newArr.length) {
        axios.post(route(ruta, {
            'ref_ciclo': formDiario.ref_ciclo,
            'arrayData': newArr,
        })).then((response) => {
            console.log(response)
            if (!props.debugInertia) Inertia.reload({ only: ['diarios'] })
        }).catch((error) => { console.log(error) })
        //console.log(newArr)


    }

    //return newArr;


}

const updateDiario = (id, asistencia = 1, content = '', percent = -1) => {
    let ruta = 'diario-actualizar'
    if (id > 0) {
        let titlesufijo = ' (A)'
        if (asistencia == 0) {
            titlesufijo = ' (F)'
        } else if (asistencia == 2) {
            titlesufijo = ' (T)'
        } else if (asistencia == 3) {
            titlesufijo = ' (FJ)'
        } else if (asistencia == 4) {
            titlesufijo = ' (TJ)'
        }
        axios.put(route(ruta), {
            'id': id,
            //'title': props.course.label + titlesufijo,
            'title': titlesufijo,
            'asistencia': asistencia,
            'content': content,
            'percent': percent,
        }).then(function (response) {
            showAlert('Registro actualizado', 'success')
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
        });
        /* Inertia.put(route(ruta, {
            'id' : id,
            'title': props.course.label + titlesufijo,
            'asistencia' : asistencia,
            'content': content,
            'percent': percent,
            //onSuccess: () => { put.completed = true }
            }
        )) */
        //Inertia.reload({ only: ['message']})
    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}

const loadAgendaRecordsForCourse = () => {
    if (!props.classroom || !props.classroom.id) return;
    axios.get(route('classroom.agenda.daily'), {
        params: {
            id_classroom: props.classroom.id,
            date: props.nowDate
        }
    }).then(res => {
        if (res.data.success && res.data.studentRecords) {
            const courseRecs = res.data.studentRecords.filter(r => r.id_course === props.course?.id);
            props.diarios.forEach(d => {
                let sId = d.id_student;
                if (!sId && props.students) {
                    const found = props.students.find(s => s.apellidos === d.apellidos && s.nombres === d.nombres);
                    if (found) {
                        sId = found.id;
                        d.id_student = found.id;
                    }
                }
                const rec = courseRecs.find(r => r.id_student === sId);
                if (rec) {
                    d.demerit_code = rec.demerit_code || '';
                    d.demerits = rec.demerits || '';
                    d.merit_code = rec.merit_code || '';
                    d.merits = rec.merits || '';
                    d.observation_course = rec.observations || '';
                } else {
                    d.demerit_code = '';
                    d.demerits = '';
                    d.merit_code = '';
                    d.merits = '';
                    d.observation_course = '';
                }
            });
        }
    }).catch(err => console.error(err));
};

const onAttendanceChange = (diario) => {
    // Guarda la asistencia en el diario general de aula
    updateDiario(diario.id, diario.asistencia, '');
};

const saveCourseAgendaRecord = (diario) => {
    let studentId = diario.id_student;
    if (!studentId && props.students) {
        const found = props.students.find(s => s.apellidos === diario.apellidos && s.nombres === diario.nombres);
        if (found) {
            studentId = found.id;
            diario.id_student = found.id;
        }
    }

    axios.post(route('classroom.agenda.student.save'), {
        id_classroom: props.classroom?.id,
        id_course: props.course?.id,
        id_diario: diario.id,
        id_student: studentId,
        date: props.nowDate,
        attendance: diario.asistencia !== null && diario.asistencia !== undefined ? diario.asistencia : 1,
        observations: diario.observation_course || null,
        demerit_code: diario.demerit_code || null,
        demerits: diario.demerits || null,
        merit_code: diario.merit_code || null,
        merits: diario.merits || null
    }).then(res => {
        showAlert(`Reporte de ${props.course.label} guardado para el alumno`, 'success');
    }).catch(err => {
        console.error(err);
        showAlert('Error al guardar en la agenda escolar', 'danger');
    });
};

const saveDiarioWithAgenda = (diario) => {
    saveCourseAgendaRecord(diario);
};

// deprecated
const listarDiario = () => {
    let ruta = ''
    Inertia.post(route(ruta, {
        'arrayData': newArr,
    }
    ))
}

// NOta postit
const nota_privada_label = ref(null)
const arrayPostit = ref([]);
const postitDescription = ref('');
const listarPostit = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/postit/listar?type_object=collaborator_classroom_course&fk_object=' + props.classroom.id + '&fk_object2=' + props.course.id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayPostit.value = respuesta.data;

        console.log(arrayPostit.value);
    }).catch(function (error) {
        console.log(error);
    });
}
const postit = ref({
    id: 0,
    description: ''
});
const getPostit = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/postit/object?type_object=collaborator_classroom_course&fk_object=' + props.classroom.id + '&fk_object2=' + props.course.id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        //postit.value = respuesta.data;
        postit.value.id = respuesta.data.id;
        postit.value.description = respuesta.data.description;

        console.log(postit.value);
    }).catch(function (error) {
        console.log(error);
    });
}
const updateOrCreatePostit = (id = 0, content = '') => {
    let ruta = 'postit-actualizar'
    let title = 'Bloc de Notas'
    if (id > 0) {
        axios.put(route(ruta), {
            'id': id,
            'description': content
        }).then(function (response) {
            //showAlert('Registro actualizado', 'success')
            showAlertPostit('actualizada')
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
            if (error.response.status == 419) {
                let alertConfirm = confirm('Se requiere actualizar por tiempo de inactividad ...')
                if (alertConfirm) {
                    window.location.href = 'login';
                }
            }
        });
    } else {
        ruta = 'postit-registrar'
        axios.post(route(ruta), {
            'type_object': 'collaborator_classroom_course',
            'fk_object': props.classroom.id,
            'fk_object2': props.course.id,
            'label': title,
            'description': content
        }).then(function (response) {
            //showAlert('Registro Creado', 'success')
            showAlertPostit('creada')
            getPostit()
            //nextTick (() => nota_privada_label.value.focus()) //focus in content
            //setTimeout(()=>{nota_privada_label.value.focus()},500)
            if (nota_privada_label.value) {
                nextTick(() => nota_privada_label.value.focus())
            }
            //console.log('Registro actualizado');
        }).catch(function (error) {
            //showAlert('Registro actualizado', 'danger', 5)
            console.log(error)
        });
    }
}

const alertPostit = ref('');
const showAlertPostit = (text = '', time = 2) => {
    alertPostit.value = text

    setTimeout(() => {
        alertPostit.value = ''
    }, time * 1000)// LRR bind(this)
}

// calificatrion
const formCalification = useForm({
    id_student: props.classroom.id,
    ref_ciclo: '',
    id_course: props.course.id,
    criterio1: '8',
    criterio2: '8',
    criterio3: '8',
    criterio4: '8',
    criterio5: '8',
    criterio6: '8',
    examen_parcial: '8',
    examen_parcial2: null,
    examen_final: '8',
    promedio: '8',
    //promedio_number: 0, creado en el controller
    status: 0

});

//const doubleCLickBlock = ref(0)
const iniciarCalification = (ref_ciclo) => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
      } */
    //doubleCLickBlock.value = 1

    // Determinar si existe Parcial 2 y asignar 8
    let existParcial2 = null
    if (tabCalif.value == 0 && props.existParcial2B1) {
        existParcial2 = true
    } else if (tabCalif.value == 1 && props.existParcial2B2) {
        existParcial2 = true
    } else if (tabCalif.value == 2 && props.existParcial2B3) {
        existParcial2 = true
    } else if (tabCalif.value == 3 && props.existParcial2B4) {
        existParcial2 = true
    } else {
        existParcial2 = false
    }

    //console.log(existParcial2)

    const newArr = [];
    const arr = props.students
    arr.forEach((student) => {
        newArr.push({
            id_student: student.id,
            id_course: formCalification.id_course,
            criterio1: formCalification.criterio1,
            criterio2: formCalification.criterio2,
            criterio3: formCalification.criterio3,
            criterio4: formCalification.criterio4,
            criterio5: formCalification.criterio5,
            criterio6: formCalification.criterio6,
            examen_parcial: formCalification.examen_parcial,
            //examen_parcial2: formCalification.examen_parcial2,
            examen_parcial2: (existParcial2 ? '8' : null),// <-- Esto es opcional pero se debe registrar si está activo
            examen_final: formCalification.examen_final,
            promedio: formCalification.promedio,
            status: 0
        });
    });
    let ruta = 'calification-registrar'
    if (newArr.length) {
        axios.post(route(ruta), {
            'ref_ciclo': ref_ciclo,
            'arrayData': newArr,

        }).then(function (response) {
            listarCalification(ref_ciclo)
            showAlert('Se inició las calificaciones del ' + ref_ciclo, 'success', 3)
            //console.log('Registro actualizado');
            console.log(newArr)
            //doubleCLickBlock.value = 0
        }).catch(function (error) {
            console.log(error);
        });

    }
    //return newArr;
}

const feedbackLabel = ref('');
const feedbackDesc = ref('');
const feedbackShow = ref(false);
let countAction = 0
let countActionOk = 0
let guardarTodo = 0
const updateCalification = (id, action, data = []) => {
    let ruta = 'calification-' + action
    if (id > 0) {

        if (action == 'actualizar') {
            //countAction++
            //alertIndex.value = 
            axios.put(route(ruta), {
                'id': id,
                'criterio1': data['criterio1'],
                'criterio2': data['criterio2'],
                'criterio3': data['criterio3'],
                'criterio4': data['criterio4'],
                'criterio5': data['criterio5'],
                'criterio6': data['criterio6'],
                'examen_parcial': data['examen_parcial'],
                'examen_parcial2': data['examen_parcial2'],
                'examen_final': data['examen_final'],
                'promedio': data['promedio'],
                'promedio_text': data['promedio_text'],
                'criterio5_peso': data['criterio5_peso'],
                'criterio6_peso': data['criterio6_peso'],
                'examen_parcial_peso': data['examen_parcial_peso'],
                'examen_parcial2_peso': data['examen_parcial2_peso'],
                'examen_final_peso': data['examen_final_peso']
            }).then((response) => {
                countAction++
                countActionOk++
                //if (!isActionMassive.value) {

                if (!guardarTodo) {
                    showAlert(countAction + ' registro actualizado', 'success')
                    countAction = 0
                    countActionOk = 0
                } else {
                    if (countAction == 1) {
                        showAlert('Validando, espere por favor ...', 'warning', 3)
                    }

                    if (arrayCalifications.value && arrayCalifications.value.length == countAction) {
                        showAlert(countActionOk + ' registros actualizados', 'success', 3)
                        countAction = 0
                        countActionOk = 0
                        guardarTodo = 0
                    }
                }


                //}  

                //console.log(countAction+' registro actualizado');
            }).catch((error) => {
                console.log(error);
                errors.value = 1
                countAction++
                //if (!isActionMassive.value) {
                showAlert(countAction + ' registro con error', 'danger', 10)
                if (!guardarTodo) {
                    countAction = 0
                } else {
                    if (arrayCalifications.value && arrayCalifications.value.length == countAction) {
                        countAction = 0
                        countActionOk = 0
                        guardarTodo = 0
                    }
                }


                //}
                //console.log(countAction+' registro con error');
            });

            /* Inertia.put(route(ruta, {
                'id' : id,
                'asistencia': data['asistencia'],
                'participacion': data['participacion'],
                'tarea': data['tarea'],
                'conducta': data['conducta'],
                'examen_parcial': data['examen_parcial'],
                'examen_parcial2': data['examen_parcial2'],
                'examen_final': data['examen_final'],
                'promedio': data['promedio'],
                onFinish: () => { 
                        put.completed = true
                        feedbackLabel.value = 'User sucessfully Added!';
                        feedbackDesc.value = usePage().props.value.flash.notification;
                        feedbackShow.value = true;
                        console.log('Actualizado')
                    }
                }
            )) */
        } else {
            axios.put(route(ruta), {
                'id': id,
            }).then(function (response) {
                showAlert('Estado actualizado', 'success')

                // Lista dependiendo en que tab está
                if (tabCalif.value == 0) {
                    console.log('Primer bimestre')
                    listarCalification(props.anioEscolar + 'B1')
                } else if (tabCalif.value == 1) {
                    console.log('Segundo bimestre')
                    listarCalification(props.anioEscolar + 'B2')
                } else if (tabCalif.value == 2) {
                    console.log('Tercer bimestre')
                    listarCalification(props.anioEscolar + 'B3')
                } else if (tabCalif.value == 3) {
                    console.log('Cuarto bimestre')
                    listarCalification(props.anioEscolar + 'B4')
                }

                console.log('Año escolar: ' + props.anioEscolar);
            }).catch(function (error) {
                console.log(error);
            });
            //listarCalification()
            //Inertia.reload({ only: ['message']})
            console.log('Año escolar: ' + props.anioEscolar);
        }

    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}

const listarCalification = (ref_ciclo) => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/calification/aula' + '?id_classroom=' + props.classroom.id + '&id_course=' + props.course.id + '&ref_ciclo=' + ref_ciclo;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayCalifications.value = respuesta;
        //console.log(arrayCalifications.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const showResp = ref([])// <-- Ver respuesta a cada tarea
const establecerShowResp = () => {
    if (taskResponses.value && taskResponses.value.length) {
        for (let i = 0; i < taskResponses.value.length; i++) {
            showResp.value[i] = false
        }
    }

}
const listarTaskResponses = (id_tarea = 0) => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/task/responses?id_course=' + props.course.id + '&id_classroom=' + props.classroom.id + '&id_task=' + id_tarea;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        taskResponses.value = respuesta;
        console.log(taskResponses.value);
        establecerShowResp()
    }).catch(function (error) {
        console.log(error);
    });
}

const diarioCollaborator = ref('')

const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar tiempo par aque no afecte la zona horaria
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + '-' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}

/* const formatNotaOut = (nota) => {
    //$rango = [8 => 'C']
    let result = (nota < 10.5 ? 'C' : (nota >= 10.5 && nota < 12.5 ? 'B' : (nota >= 12.5 && nota < 16.5 ? 'A' : (nota >= 16.5 && nota <= 20 ? 'AD' : 'E'))))
    return result

}

const formatNotaIn = (nota) => {
    //$rango = [8 => 'C']
    let result = (nota == 'C' ? 10 : (nota == 'B' ? 13 : (nota == 'A' ? 17 : (nota == 'AD' ? 20 : 0))))
    return result

} */

const nota2number = (nota) => {
    let result = (nota == 'C' ? 10 : (nota == 'B' ? 13 : (nota == 'A' ? 17 : (nota == 'AD' ? 20 : 0))))
    return result
}

const number2nota = (notaN) => {
    let nota = parseFloat(notaN).toFixed(2);
    let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
    //console.log(nota)
    return result
}

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

// Se creó un compoente de alert
/* const notificationSettingsModel = ref([]);
const notificationsOutline = computed(
  () => notificationSettingsModel.value.indexOf("outline") > -1
); */

const isModalFormFullActive = ref(false);
//const isModalForm = ref(false); 

// Adjuntar archivo
const formFile = useForm({
    id: 0,
    file: null,
    filename: '',
    //oldfilepath: '',
    //oldfilename: '',
    originName: '',
    src_object_type: 'file_task',
    src_object_id: rowParentID.value ?? null,
    name: '',
    terms: false,
    type: ''
});


const isSaveFile = ref(false)
const isImagen = ref(false)
const imgMiniatura = ref('')
const handleFileUp = (event) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    //fileSubida.value = event.target.files[0];
    //console.log(event.target.files[0]);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (event.target.files && event.target.files.length) {
        formFile.originName = event.target.files[0].name
        if (formFile.originName.includes('.jpg') || formFile.originName.includes('.png')) {
            isImagen.value = true
        } else {
            isImagen.value = false
        }

        let file = event.target.files[0];
        //this.product.imagen=file
        formFile.file = file
        //console.log(file)
        console.log(formFile.file)
        fileUp(file)
    }

}

const fileUp = (file) => {
    let reader = new FileReader()
    reader.onload = (e) => {
        imgMiniatura.value = e.target.result
    }
    reader.readAsDataURL(file)
}

const registrarFile = () => {
    let currentObj = this;
    let ruta = 'file-adjunto-registrar'
    const config = {
        onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
    }
    axios.post(route(ruta), {

        'file': formFile.file,
        'filename': formFile.filename,
        'originName': formFile.originName,
        'src_object_type': formFile.src_object_type,
        'src_object_id': formFile.src_object_id,
        'name': formFile.name,
        'terms': formFile.terms,
        'type': formFile.type

    }, config).then(function (response) { // <-- config para enviara headers en este caso para subir archivo
        //Inertia.reload({ only: ['tasks']})
        isSaveFile.value = true
        //showAlert('Se adjuntó un archivo ', 'success', 2)
        responseMsg.value = response.data.success
        console.log('Adjuntado : ' + formFile.src_object_type + ' - ' + formFile.src_object_id);
    }).catch(function (error) {
        console.log(error);
        responseMsg.value = error

    });
}

// Otra forma de subir archivo
const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
const resourceTypeLink = ref(false)
const fileResource = ref(null)// <-- Ref es el ref del input con el mismo nombre
const fileTask = ref(null)
const fileSize = ref(0)
const selectedFileName = ref('')
const selectedFilesList = ref([])
const isUploadingFile = ref(false)

const changeFile = (type) => {
    let file = null;
    if (type == 'file_resource') {
        const files = Array.from(fileResource.value?.files || []);
        selectedFilesList.value = files.map(f => ({
            name: f.name,
            size: f.size,
            nameSinExtension: f.name.replace(/\.[^/.]+$/, "")
        }));
        if (files.length === 1) {
            file = files[0];
            fileSize.value = file.size;
            selectedFileName.value = file.name;
            inputFileName.value = file.name.replace(/\.[^/.]+$/, "");
        } else if (files.length > 1) {
            fileSize.value = Math.max(...files.map(f => f.size));
            selectedFileName.value = `${files.length} archivos seleccionados`;
            inputFileName.value = '';
        } else {
            fileSize.value = 0;
            selectedFileName.value = '';
            inputFileName.value = '';
        }
        return;
    } else if (type == 'file_task') {
        file = fileTask.value?.files?.[0];
    }

    if (file) {
        fileSize.value = file.size;
        selectedFileName.value = file.name;
        let fileName = file.name;
        let nameSinExtension = fileName.replace(/\.[^/.]+$/, "");
        inputFileName.value = nameSinExtension;
    }
}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    if (type == 'file_resource') {
        const files = fileResource.value?.files;
        if (!files || files.length === 0) {
            showAlert('Seleccione al menos un archivo', 'warning', 3);
            return Promise.resolve();
        }

        data.append('origin_type', type);
        data.append('origin_id', props.classroom.id);
        data.append('origin_id2', props.course.id);
        data.append('name', inputFileName.value || '');
        data.append('description', inputFileDesc.value || '');
        data.append('position', inputFilePos.value || 1);

        for (let i = 0; i < files.length; i++) {
            data.append('files[]', files[i]);
        }
        if (files.length === 1) {
            data.append('file', files[0]);
        }

        isUploadingFile.value = true;
        return axios.post('/file/upload', data)
            .then(response => {
                isUploadingFile.value = false;
                if (response.data.error) {
                    showAlert(response.data.message, 'danger', 5);
                } else if (response.data.success) {
                    showAlert(response.data.message, 'success', 3);
                    cleanInputFile();
                    if (!props.debugInertia) Inertia.reload({ only: ['resources'] });
                }
                return response;
            })
            .catch(error => {
                isUploadingFile.value = false;
                console.error(error);
                showAlert('Error al subir los archivos', 'danger', 5);
                throw error;
            });
    }

    let file = null;
    if (type == 'file_task') {
        file = fileTask.value?.files?.[0];
    }
    if (!file) return Promise.resolve();

    data.append('file', file)
    data.append('origin_type', type)
    data.append('origin_id', origin_id)
    data.append('name', inputFileName.value || ('TAREA' + origin_id))
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)

    return axios.post('/file/upload', data)
        .then(response => {
            if (response.data.error) {
                showAlert(response.data.message, 'danger', 5)
                if (type == 'file_task') {
                    errorMessage.value = response.data.message
                }
            } else if (response.data.success) {
                showAlert(response.data.message, 'success', 2)
                cleanInputFile()
                if (type == 'file_task') {
                    if (!props.debugInertia) Inertia.reload({ only: ['tasks'] })
                }
            }
            return response;
        })
        .catch(error => {
            console.log(error)
            throw error;
        })
}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    showInputFile.value = false
    resourceTypeLink.value = false
    selectedFilesList.value = []
    selectedFileName.value = ''
    fileSize.value = 0
    formLink.label = ''
    formLink.url = ''
    if (fileResource.value) fileResource.value.value = ''
    if (fileTask.value) fileTask.value.value = ''
}

const ShowDeleteFile = ref(false)
const deleteFile = (id_file, type = 'file_task') => {
    let ruta = 'file-adjunto-eliminar'
    if (type == 'file_resource') {
        ruta = 'file-eliminar'
    } else if (type == 'file_task') {
        ruta = 'file-eliminar'
    }

    axios.post(route(ruta), {
        'id': id_file,
        'src_object_type': type,

    }).then((response) => {
        if (response.data.error) {
            showAlert(response.data.message, 'danger', 5)
        } else if (response.data.success) {
            showAlert(response.data.message, 'success', 2)
            rowID.value = 0
            rowAction.value = ''
            //Inertia.reload({ only: ['resources']})
            if (type == 'file_resource') {
                if (!props.debugInertia) Inertia.reload({ only: ['resources'] })
            } else if (type == 'file_task') {
                if (!props.debugInertia) Inertia.reload({ only: ['tasks'] })
            }
        }
    }).catch((error) => {
        console.log(error);
    });

}

const isActionMassive = ref(false)
const updateArrayCalifications = (bimestre = '') => {
    isActionMassive.value = true
    guardarTodo = 1
    let buttons = document.getElementsByName('buttonssave' + bimestre);
    //let count = 0
    //let lastIt = buttons.length - 1
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].click();
        //count ++
        //if (i == buttons.length -1) {
        //countAction = 0
        //guardarTodo = 0
        /* if(errors.value) {
            showAlert(' registrado con errores', 'danger', 10)
            isActionMassive.value = false
            errors.value = 0
        } else {
            showAlert((i+1) + ' registros actualizados', 'success', 5)
            //isActionMassive.value = false
        } */
        //} 
    }

    // La última iteración
    /* if (count == buttons.length) {
        if (errors.value) {
            showAlert((alertIndex+1) + ' registro con errores', 'danger', 10)
            //wait(1000)
            setTimeout( () => {
                isActionMassive.value = false
            }, 10*1000)
        } else {
            showAlert(count + ' registrados guardados de ' + buttons.length, 'success', 5)
            //showAlert(count + ' registros actualizados', 'success', 5)
            //wait(1000)
            setTimeout( () => {
                isActionMassive.value = false
            }, 5*1000)
        }
    }
    console.log(count + ' - ' + buttons.length) */


}

/* Podrías solucionarlo así:

Para detectar la tecla presionada deberías utilizar key, ya que keyCode esta deprecado.

Para evitar que se envíe el formulario deberías utilizar preventDefault

Ejemplo: */
// keypress detecta Tab como si fuera Enter ahora usar -> keydown para detectar otras teclas como Ctrl y diferencia el Tab
document.addEventListener('keydown', function (evt) {
    //console.log(evt)
    // Si el evento NO es una tecla Enter
    if (evt.key !== 'Enter' && evt.key !== 'Control') {
        return;
    }

    let element = evt.target;

    // Si el evento NO fue lanzado por un elemento con class "focusNext"
    if (!element.classList.contains('focusNext')) {
        return;
    }

    // AQUI logica para encontrar el siguiente debajo
    let tabIndexOrigin = element.tabIndex;
    let tabIndexNext = tabIndexOrigin;

    // En algunos navegadores el Enter y Tab hacen los mismo con keypress pero ahora usaremos keydown
    if (evt.key === 'Enter') {
        tabIndexNext = tabIndexNext + 1;
    } else if (evt.key === 'Control') {
        // Tab
        tabIndexNext = tabIndexNext + 100; // Encontra al lado derecho pues crece de 100 en 100
    }

    //console.log(element.value)
    // si la nota es inconsistencia mostrar alerta
    let inconsistencia = alertMinMax(element.value, 0)
    if (inconsistencia) {
        tabIndexNext = tabIndexOrigin
    }

    //console.log(tabIndexNext)
    var next = document.querySelector('[tabindex="' + tabIndexNext + '"]');

    // Si encontramos un elemento
    if (next) {
        next.focus();
        // No es neceasrio qye no usamos un form
        //Event.preventDefault();
    }
});

const backLink = ref(props.back_link ? '/#' + props.back_link : '')

// Block right menu. Maestro no puede hacer click derecho
/* if (props.isMaster) {
    document.addEventListener("contextmenu", function(e){
        e.preventDefault();
        alert('Only Read Right Click');
    }, false);
    //var myEmbed = document.getElementById('embedFullView');
    //myEmbed.window.eval('document.addEventListener("contextmenu", function(e){ e.preventDefault(); }, false)')
} */
//document.onmousedown = disableRightclick;
/* const disableRightClick = (evt) => {
    if(evt.button == 2){
        alert('Only Read');
        return false;    
    }
    
} */

// Clase dinamica para ordenar botones de puntos listado de opciones, caso tareas
const relativeDots = ref(true)

// Tab
//openTab: 1
const openTab = ref(1);
const toggleTabs = (tabNumber) => {
    openTab.value = tabNumber
}

const tabsMenu = computed(() => [
    { id: 1, label: 'Contenido', icon: 'tabler:book', show: props.classroom.id_level == props.course.id_level },
    { id: 2, label: 'Alumnos', icon: 'tabler:users-group', show: true },
    { id: 3, label: 'Asistencia', icon: 'tabler:calendar-check', show: true },
    { id: 4, label: 'Tareas/Prácticas', icon: 'tabler:edit', show: props.classroom.id_level == props.course.id_level },
    { id: 5, label: 'Recursos', icon: 'tabler:folder', show: props.classroom.id_level == props.course.id_level },
    { id: 6, label: 'Calificaciones', icon: 'tabler:award', show: props.classroom.id_level == props.course.id_level },
    { id: 7, label: 'Anuncios', icon: 'tabler:speakerphone', show: true }
]);


/***
 * LRR Notas
 * los tipos radio sólo se abren una vez, si se cambia a checkbox entonces se puede abrir independiente cada uno y cerrar
 */

const isPostitActive = ref(false);
const showAyuda = ref([
    { 'listadoalumnos': false },
    { 'registroasistencia': false },
    { 'tareas': false },
    { 'recursosdeestudio': false },
    { 'calificaciones': false }
])

const trans = ref() // <-- Transformar objecto reactivo
const langs = () => {
    //let url = '/lang/traducir' + '?transkey=' + transkey + '&id_level=' + props.classroom.id_level;
    let url = '/lang/traducir?id_level=' + props.classroom.id_level;
    //return axios.get(url).then(response => response.data)

    /* const response = await axios.get(url)
    return response.data */

    //var transvalue = '';
    axios.get(url).then((response) => {
        let respuesta = response.data;
        console.log(respuesta);
        if (respuesta) {
            trans.value = respuesta;
            //console.log('Traducido: ' + trans[transkey].value);
        } else {
            //trans.value = transkey;
        }

    }).catch((error) => {
        console.log(error);
        //transvalue = transkey;
    });
    //return transvalue;
}

// Anuncio
const formAnuncio = useForm({
    id: 0,
    label: '',
    description: '',
    id_classroom: props.classroom.id,
    id_course: props.course.id
})
const createAnuncio = ref(false)
const errorAnuncio = ref('')
const anuncioUpdateOrCreate = (id = 0, action = '') => {
    let ruta = 'anuncio-registrar';
    if (id > 0) {
        ruta = 'anuncio-actualizar';
        ruta = 'anuncio-' + action;
        formAnuncio.id = id
    } else {
        // validar al registrar
        if (!formAnuncio.label) {
            errorAnuncio.value = 'Debe ingresar un texto'
        } else {
            errorAnuncio.value = ''
        }
    }

    if (!errorAnuncio.value) {
        axios.post(route(ruta), formAnuncio).then((response) => {
            if (response.data.error) {
                //showAlert(response.data.message, 'danger', 5)
                //errorMessage.value = response.data.message
                errorAnuncio.value = response.data.error;
            } else if (response.data.success) {
                //showAlert(response.data.message, 'success', 2)
                //successMessage.value == response.data.message
                Inertia.reload({ only: ['anuncios'] })
                createAnuncio.value = false
                console.log('Anuncio creado')
            }

        }).catch((error) => {
            console.log(error);
        });
    }

}

const anuncio_label = ref(null)
const initCreateAnuncio = () => {
    createAnuncio.value = true
    nextTick(() => anuncio_label.value.focus())
}

// NOt funciona
/* const traducir = (transkey='') => {
    

    if (trans[transkey].value) {
        return trans[transkey].value;
    }
    
    return transkey;
} */

/**
 * Temario
 */
const rowTemas = ref([])
// Declarar índice de temas para abrir y cerrar
const declareRows = (type = '') => {
    if (type == 'temas') {
        props.temas.forEach((field, index) => {
            if (field.id > 0) {
                rowTemas.value[index] = false
            }
        })

    }
    /* if (type == 'coord') {
        prop.ayudaColaborador.forEach((field, index) => {
            if (field.id > 0) {
                rowCoord.value[index] = false
            }
        })

    }
    if (type == 'maestro') {
        prop.ayudaMaestro.forEach((field, index) => {
            if (field.id > 0) {
                rowMaestro.value[index] = false
            }
        })

    } */
}

// Instancia para acceder a propiedades globales
const internalInstance = getCurrentInstance();

// Constantes de nota mínima y máxima
const notaMinimaInput = computed(() => {
    const pageProps = usePage()?.props?.value;
    const cGlobal = internalInstance?.proxy?.confGlobal?.value || pageProps?.confGlobal;
    const minVal = cGlobal?.CALIFICATION_NOTA_MINIMA_INPUT;
    return (minVal !== undefined && minVal !== null && minVal !== '') ? Number(minVal) : 8;
});

const notaMaximaInput = computed(() => {
    const pageProps = usePage()?.props?.value;
    const cGlobal = internalInstance?.proxy?.confGlobal?.value || pageProps?.confGlobal;
    const maxVal = cGlobal?.CALIFICATION_NOTA_MAXIMA_INPUT;
    return (maxVal !== undefined && maxVal !== null && maxVal !== '') ? Number(maxVal) : 20;
});

// Forzar mínimo y maximo del input
const alertMinMax = (el, showAlert = 1) => {
    let val = (el && typeof el === 'object' && 'value' in el) ? el.value : el;
    let nota = Number(val);
    const min = notaMinimaInput.value;
    const max = notaMaximaInput.value;
    if (val === '' || isNaN(nota) || nota < min || nota > max) {
        if (showAlert) {
            modalAlertState.value = {
                show: true,
                title: 'Calificación Inválida',
                message: `La nota ingresada no es válida. Debe estar en el rango de ${min} a ${max}.`,
                type: 'error',
                icon: 'tabler:circle-x',
                showCloseButton: true,
                closeButtonText: 'Corregirlo ahora',
                closeButtonColor: 'error'
            };
            if (el && typeof el === 'object' && 'focus' in el) {
                setTimeout(() => {
                    el.focus();
                    if ('select' in el) el.select();
                }, 0);
            }
        }
        return 1;
    } else {
        return 0;
    }
};

const isNotaInvalida = (nota) => {
    if (nota === null || nota === undefined || String(nota).trim() === '') return false;
    let n = Number(nota);
    const min = notaMinimaInput.value;
    const max = notaMaximaInput.value;
    return isNaN(n) || n < min || n > max;
};

const hasInvalidGrades = computed(() => {
    return arrayCalifications.value.some(cal => {
        return isNotaInvalida(cal.criterio1) ||
            isNotaInvalida(cal.criterio2) ||
            isNotaInvalida(cal.criterio3) ||
            isNotaInvalida(cal.criterio4) ||
            isNotaInvalida(cal.criterio5) ||
            isNotaInvalida(cal.criterio6) ||
            isNotaInvalida(cal.examen_parcial) ||
            isNotaInvalida(cal.examen_parcial2) ||
            isNotaInvalida(cal.examen_final);
    });
});

// Exportar calificaciones

const { exportGradesData } = useGradesExport();

const loadingExport = ref(false)

const handleGradesExport = async (format, headers = null) => {
    let activeHeaders = headers;

    if (!activeHeaders) {
        const cycleLabels = ['PRIMER', 'SEGUNDO', 'TERCER', 'CUARTO'];
        const cycleSuffix = cycleLabels[tabCalif.value] || 'PRIMER';

        // Intentamos obtener la configuración de múltiples fuentes para máxima robustez
        const pageProps = usePage()?.props?.value;
        const cGlobal = internalInstance?.proxy?.confGlobal || pageProps?.confGlobal;

        const configKey = `EXAMEN_PARCIAL2_${cycleSuffix}_BIMESTRE`;
        const hasParcial2 = cGlobal?.value?.[configKey] == 1 || cGlobal?.[configKey] == 1;

        activeHeaders = [
            { key: 'index', label: '#' },
            { key: 'alumno', label: 'Alumno' }, // Apellidos y nombres
            // Se agrega en el template { key: 'type', label: 'Categoría' },
            { key: 'criterio1', label: trans.value?.criterio1 || 'Criterio 1', title: trans.value?.criterio1 || 'Criterio 1', condition: !!trans.value?.criterio1 },
            { key: 'criterio2', label: trans.value?.criterio2 || 'Criterio 2', title: trans.value?.criterio2 || 'Criterio 2', condition: !!trans.value?.criterio2 },
            { key: 'criterio3', label: trans.value?.criterio3 || 'Criterio 3', title: trans.value?.criterio3 || 'Criterio 3', condition: !!trans.value?.criterio3 },
            { key: 'criterio4', label: trans.value?.criterio4 || 'Criterio 4', title: trans.value?.criterio4 || 'Criterio 4', condition: !!trans.value?.criterio4 },
            { key: 'criterio5', label: trans.value?.criterio5 || 'Criterio 5', title: trans.value?.criterio5 || 'Criterio 5', class: 'text-center', condition: !!trans.value?.criterio5 },
            { key: 'criterio6', label: trans.value?.criterio6 || 'Criterio 6', title: trans.value?.criterio6 || 'Criterio 6', class: 'text-center', condition: !!trans.value?.criterio6 },
            { key: 'examen_parcial', label: 'Ex. parcial', title: 'Examen parcial' },
            { key: 'examen_parcial2', label: 'Ex. parcial2', title: 'Examen parcial2', condition: hasParcial2 },
            { key: 'examen_final', label: 'Ex. final', title: 'Examen final' },
            { key: 'promedio', label: 'Promedio', title: 'Promedio' }
        ];
    }

    if (arrayCalifications.value.length === 0) {
        return;
    }

    loadingExport.value = true;
    let titleTab = '';

    if (tabCalif.value === 0) {
        titleTab = 'PRIMER BIMESTRE';
    } else if (tabCalif.value === 1) {
        titleTab = 'SEGUNDO BIMESTRE';
    } else if (tabCalif.value === 2) {
        titleTab = 'TERCER BIMESTRE';
    } else if (tabCalif.value === 3) {
        titleTab = 'CUARTO BIMESTRE';
    } else {
        titleTab = 'NOTAS';
    }

    // Usamos todos los headers que provienen de TableResponsive o los generados
    // useGradesExport ya filtra noexport, actions, etc. Pero por precaución mandamos los correctos.
    const validHeaders = activeHeaders.filter(h => h.key !== 'index' && h.key !== 'actions' && h.key !== 'log' && h.key !== 'alumno' && h.key !== 'type' && h.condition !== false);

    const userName = usePage().props.value?.auth?.user?.nombres
        ? usePage().props.value.auth.user.nombres + ' ' + (usePage().props.value.auth.user.apellidos || '')
        : usePage().props.value?.auth?.user?.name || '';

    if (format === 'pdf' || format === 'xlsx' || format === 'view') {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = route('reportcalification-exportClassroom');
        if (format === 'view') {
            form.target = '_blank';
        }

        const dataInput = document.createElement('input');
        dataInput.type = 'hidden';
        dataInput.name = 'data';
        dataInput.value = JSON.stringify({
            records: arrayCalifications.value,
            classroom: props.classroom,
            course: props.course,
            teacher: { name: userName },
            tabRecords: validHeaders, // <-- validHeaders.filter(h => h.key !== 'alumno') Se reubicó arriba
            activeTab: titleTab,
            format: format
        });

        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

        form.appendChild(dataInput);
        form.appendChild(csrfInput);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
        loadingExport.value = false;
        return;
    }

    // Excel de vista usando JS si format == 'xlsx_js'
    try {
        await exportGradesData({
            ext: format,
            data: arrayCalifications.value,
            columns: validHeaders,
            metadata: {
                titulo: titleTab,
                curso: props.course?.label || '',
                grado: props.classroom?.ref || props.classroom?.grado || '',
                seccion: props.classroom?.seccion || '',
                profesor: userName,
                nivel: props.classroom?.nivel_name || props.classroom?.label_level || ''
            }
        });
    } catch (err) {
        console.error("Error exporting", err);
    } finally {
        loadingExport.value = false;
    }
}

</script>

<template>

    <Head :title="classroom.label" />
    <!-- <div v-if="isAlertActive" class="container mx-auto px-8 sticky top-1 z-50">
        <div class="grid-cols-1 w-full flex justify-end">
            <NotificationBar :color="colorAlert" :icon="(colorAlert=='success' ? mdiCheckCircle : (colorAlert=='warning' ? mdiContrastCircle : mdiAlertCircle))"
                :outline="notificationsOutline"  class="col-span-1 p-2 lg:p-4 absolute">
                <b v-if="colorAlert=='success'">Ok </b>
                <b v-else-if="colorAlert=='warning'">! </b>
                <b v-else-if="colorAlert=='danger'">Error </b>
                <span class="mr-3" v-text="messageAlert"></span>
            </NotificationBar>
        </div>
    </div> -->
    <!-- Analizar esto, los alert tiene que star debajo de otro-->
    <NotificationAlert v-model="isAlertDangerActive" :message="messageAlert" color="danger" />
    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />
    <!-- <div v-if="isAlertActive" class="container mx-auto px-8 sticky top-1 z-50">
        <div class="grid-cols-1 w-full flex justify-end">
            <div class="col-span-1 p-2 lg:p-4 absolute">
                <div>
                    <div class="py-3 px-5 text-blue-900 text-sm rounded-md border border-blue-200 flex items-center justify-between"
                    role="alert" :class="(colorAlert=='warning' ? 'bg-yellow-100' : (colorAlert=='danger' ? 'bg-red-100' : 'bg-green-100'))">
                    <span class="mr-3">{{ messageAlert }}</span>
                    <button class="h-6 w-6" type="button" data-dismiss="alert" aria-label="Close"
                        onclick="this.parentElement.remove();">
                        <BaseIcon :path="mdiCloseThick" class="text-gray-700" :size="28" />
                    </button>
                </div>
                </div>
                
            </div>
        </div>
        
    </div> -->
    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader :title="course.label + ' (' + level_course.label + ')'" :subtitle="'AULA: ' + classroom.label + ' • ' + students.length + ' Alumnos'" icon="tabler:book" color="rose">
                
                <template #actions>
                    <div class="hidden sm:flex items-center gap-3 bg-rose-50 border border-rose-200 rounded-lg px-3 py-1 shadow-sm mr-2">
                        <div class="text-rose-600 font-bold flex flex-col items-center leading-none">
                            <span class="text-[10px] uppercase">{{ nowMonthLetter.substring(0, 3) }}</span>
                            <span class="text-xl">{{ nowDay }}</span>
                        </div>
                        <div class="text-slate-700 text-xs flex flex-col">
                            <span class="font-bold">Semana {{ semanaActual }}</span>
                            <span>{{ bimestreActual }}</span>
                        </div>
                    </div>
                    <button @click="isPostitActive = !isPostitActive" class="w-10 h-10 flex items-center justify-center rounded-full bg-amber-100 hover:bg-amber-200 text-amber-700 relative shadow-sm border border-amber-200 transition" title="Nota Privada">
                        <Icon icon="iconoir:post" class="w-5 h-5" />
                        <span v-if="postit.description" class="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full border-2 border-white"></span>
                    </button>
                    <span v-if="classroom.id_level != course.id_level" class="text-sm font-semibold text-rose-600 bg-rose-50 dark:bg-rose-950/30 px-3 py-1 rounded-lg border border-rose-200">
                        Inconsistencia en asignación del curso, consulte con el coordinador!
                    </span>
                    <Buttons v-if="backLink" :href="route('classrooms-collaborator') + backLink" size="vuexy"  icon="tabler:arrow-left" label="Volver al Listado" color="gray" />
                    <Buttons v-else :href="route('classrooms-collaborator')" size="vuexy" icon="tabler:arrow-left" label="Volver al Listado" color="gray" />
                </template>
                <template #bottom>
                    <PremiumTabs v-model="openTab" :tabs="tabsMenu" />
                </template>
            </PremiumPageHeader>
        </template>

        <!-- Vista previa guia de estudio -->
        <!-- Uso de carbox modal IMG -->
        <CardBoxModal v-model="isModalFullActive" :title="modalSize === 'presentation' ? 'Presentación' : 'Vista previa'" :sizeModal="modalSize" hasCancel isFullScreen>
            <!-- tien el botón de cancelar superior-->

            <!-- Si se quiere respetar el tamaño real de la imagen en Presentación separa img y embed -->
            <!-- <div class="flex justify-center items-center w-full h-full object-contain absolute" :class="srcParamOnlyRead ? 'view-wrapper' : ''">
                <img v-if="modalFullSrc && ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(modalFullSrc.split('.').pop().toLowerCase())" :src="modalFullSrc" class="max-h-full max-w-full object-contain" />
                <embed v-else :src="modalFullSrc + srcParamOnlyRead" class="h-full w-full object-contain" />
                <div v-if="srcParamOnlyRead" class="view-embed-cover"></div>
            </div> -->

            <div class="flex justify-center items-center w-full h-full object-contain absolute" :class="srcParamOnlyRead ? 'view-wrapper' : ''">
                <!-- src="modalFullSrc + (isCoord ? '#toolbar=0' : '')" class="min-h <-- Mejor mostrar siempre -->
                <embed :src="modalFullSrc + srcParamOnlyRead" class="h-full w-full object-contain" :oncontextmenu="(isMaster || isCoord ? false : true)" :class="(modalFullSrc && (['pdf', 'xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop())) ? 'w-full' : 'w-auto ')"><!-- w-full es para documetnos w-auto para imágenes ---  Otro uso :style="(isCoord ? '#downloads {display: none;}' : '')" -->
                <div v-if="srcParamOnlyRead" class="view-embed-cover"></div>
            </div>
        </CardBoxModal>

        <!-- Tareas-->
        <CardBoxModal v-model="isModalActive" hasCancel :title="rowAction == 'registrar' ? 'Registrar tarea' : (rowAction == 'actualizar' ? 'Editar tarea' : (rowAction == 'leer' ? 'Detalle de la tarea' : (rowAction == 'leer-respuesta' ? 'Respuesta del estudiante' : (rowAction == 'tarearesponse-actualizarresp' ? 'Calificar respuesta' : titleModal + ' registro'))))" @confirm="isConfirm" @cancel="isCancel" sizeModal="medium" :noButtons="(rowAction == 'leer' || rowAction == 'leer-respuesta' ? true : false)">
            <div v-if="isErrorForm" class="mb-4 p-3 bg-red-50 dark:bg-red-950/30 rounded-xl border border-red-200 dark:border-red-900/50">
                <div class="text-xs font-semibold text-red-600 dark:text-red-400">Ups! Debe registrar los campos requeridos (Título y Periodo) *</div>
            </div>

            <div v-if="rowAction != 'tarearesponse-actualizarresp' && rowAction != 'leer-respuesta' && rowAction != 'actualizarFile' && rowAction != 'actualizarLink'" class="space-y-4">
                <!-- 1. Bimestre -->
                <div>
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Periodo / Bimestre <span class="text-red-500">*</span></label>
                    <select v-model="formTarea.ref_ciclo" :disabled="(rowAction == 'leer' ? true : false)" required class="border-gray-300 dark:border-gray-700 dark:bg-slate-800 focus:border-indigo-500 focus:ring focus:ring-indigo-200 rounded-xl shadow-xs block w-full text-xs">
                        <option value="" disabled>Selección del Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'">Primer Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'">Segundo Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'">Tercer Bimestre</option>
                        <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'">Cuarto Bimestre</option>
                    </select>
                </div>

                <!-- 2. Tipo de Recepción (Digital vs Físico) -->
                <div v-if="rowAction == 'registrar' || rowAction == 'actualizar' || rowAction == 'leer'">
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">Modalidad de Recepción de la Tarea <span class="text-red-500">*</span></label>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                        <label 
                            :class="[
                                'flex items-start gap-3 p-3 rounded-xl border-2 transition-all select-none',
                                rowAction == 'leer' ? 'opacity-90 cursor-default' : 'cursor-pointer',
                                formTarea.delivery_type !== 'fisico' 
                                    ? 'border-blue-500 bg-blue-50/70 dark:bg-blue-950/30 text-blue-950 dark:text-blue-200 shadow-xs' 
                                    : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300'
                            ]"
                        >
                            <input type="radio" value="digital" v-model="formTarea.delivery_type" :disabled="rowAction == 'leer'" class="sr-only" />
                            <div class="mt-0.5 w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0" :class="formTarea.delivery_type !== 'fisico' ? 'border-blue-600 bg-blue-600' : 'border-slate-400'">
                                <span v-if="formTarea.delivery_type !== 'fisico'" class="w-1.5 h-1.5 rounded-full bg-white"></span>
                            </div>
                            <div class="text-xs">
                                <div class="font-bold flex items-center gap-1.5">
                                    <BaseIcon :path="mdiCloudUploadOutline" :size="16" class="text-blue-600" />
                                    <span>Entrega Digital</span>
                                </div>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">Los alumnos responderán y subirán archivos por la plataforma.</p>
                            </div>
                        </label>

                        <label 
                            :class="[
                                'flex items-start gap-3 p-3 rounded-xl border-2 transition-all select-none',
                                rowAction == 'leer' ? 'opacity-90 cursor-default' : 'cursor-pointer',
                                formTarea.delivery_type === 'fisico' 
                                    ? 'border-purple-500 bg-purple-50/70 dark:bg-purple-950/30 text-purple-950 dark:text-purple-200 shadow-xs' 
                                    : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300'
                            ]"
                        >
                            <input type="radio" value="fisico" v-model="formTarea.delivery_type" :disabled="rowAction == 'leer'" class="sr-only" />
                            <div class="mt-0.5 w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0" :class="formTarea.delivery_type === 'fisico' ? 'border-purple-600 bg-purple-600' : 'border-slate-400'">
                                <span v-if="formTarea.delivery_type === 'fisico'" class="w-1.5 h-1.5 rounded-full bg-white"></span>
                            </div>
                            <div class="text-xs">
                                <div class="font-bold flex items-center gap-1.5">
                                    <BaseIcon :path="mdiBook" :size="16" class="text-purple-600" />
                                    <span>Recepción Física</span>
                                </div>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">Desarrollo en cuaderno / hojas. No requiere respuesta digital.</p>
                            </div>
                        </label>
                    </div>
                </div>

                <!-- 3. ¿Es Calificada? (is_graded) -->
                <div v-if="rowAction == 'registrar' || rowAction == 'actualizar' || rowAction == 'leer'">
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">¿Esta tarea será calificada con nota? <span class="text-red-500">*</span></label>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                        <label 
                            :class="[
                                'flex items-center gap-2.5 p-2.5 rounded-xl border-2 transition-all select-none',
                                rowAction == 'leer' ? 'opacity-90 cursor-default' : 'cursor-pointer',
                                formTarea.is_graded == 1 
                                    ? 'border-emerald-500 bg-emerald-50/60 dark:bg-emerald-950/30 text-emerald-950 dark:text-emerald-200' 
                                    : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300'
                            ]"
                        >
                            <input type="radio" :value="1" v-model="formTarea.is_graded" :disabled="rowAction == 'leer'" class="sr-only" />
                            <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0" :class="formTarea.is_graded == 1 ? 'border-emerald-600 bg-emerald-600' : 'border-slate-400'">
                                <span v-if="formTarea.is_graded == 1" class="w-1.5 h-1.5 rounded-full bg-white"></span>
                            </div>
                            <span class="text-xs font-bold">Sí, con calificación (nota numérica)</span>
                        </label>

                        <label 
                            :class="[
                                'flex items-center gap-2.5 p-2.5 rounded-xl border-2 transition-all select-none',
                                rowAction == 'leer' ? 'opacity-90 cursor-default' : 'cursor-pointer',
                                formTarea.is_graded == 0 
                                    ? 'border-amber-500 bg-amber-50/60 dark:bg-amber-950/30 text-amber-950 dark:text-amber-200' 
                                    : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300'
                            ]"
                        >
                            <input type="radio" :value="0" v-model="formTarea.is_graded" :disabled="rowAction == 'leer'" class="sr-only" />
                            <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0" :class="formTarea.is_graded == 0 ? 'border-amber-600 bg-amber-600' : 'border-slate-400'">
                                <span v-if="formTarea.is_graded == 0" class="w-1.5 h-1.5 rounded-full bg-white"></span>
                            </div>
                            <span class="text-xs font-bold">No, tarea formativa (sin nota)</span>
                        </label>
                    </div>
                </div>

                <!-- 4. Título -->
                <div>
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Título de la tarea <span class="text-red-500">*</span></label>
                    <BreezeInput id="label" type="text" class="block w-full rounded-xl text-xs" v-model="formTarea.label" :disabled="(rowAction == 'leer' ? true : false)" required autocomplete="label" placeholder="Ej: Desarrollar hoja de trabajo para pegarlo en cuaderno" />
                </div>

                <!-- 5. Fechas -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Fecha de publicación</label>
                        <input type="date" class="w-full rounded-xl border-gray-300 dark:border-gray-700 dark:bg-slate-800 text-xs py-2 px-3 focus:border-indigo-500" v-model="formTarea.start_date" :disabled="(rowAction == 'leer' ? true : false)">
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">
                            Finaliza la entrega el <span class="text-slate-400 font-normal text-[11px]">(opcional)</span>
                        </label>
                        <input type="datetime-local" class="w-full rounded-xl border-gray-300 dark:border-gray-700 dark:bg-slate-800 text-xs py-2 px-3 focus:border-indigo-500" v-model="formTarea.end_date" :disabled="(rowAction == 'leer' ? true : false)">
                    </div>
                </div>

                <!-- 6. Descripción -->
                <div>
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">
                        Descripción / Indicaciones <span class="text-slate-400 font-normal text-[11px]">(opcional)</span>
                    </label>
                    <QuillEditor v-if="rowAction == 'leer'" ref="tareaEditor" style="min-height:100px;" v-model:content="formTarea.description" contentType="html" :toolbar="[]" theme="snow" readOnly />
                    <QuillEditor v-else ref="tareaEditor" style="min-height:100px;" v-model:content="formTarea.description" contentType="html" toolbar="essential" theme="snow" placeholder="Escriba aquí las indicaciones de la tarea..." />
                </div>

                <!-- 7. Adjuntar archivo al crear -->
                <div v-if="rowAction == 'registrar'" class="p-3.5 bg-slate-50 dark:bg-slate-800/60 rounded-2xl border border-slate-200 dark:border-slate-700 space-y-2">
                    <div class="flex items-center gap-2">
                        <BaseIcon :path="mdiPaperclip" :size="16" class="text-blue-600" />
                        <span class="text-xs font-bold text-slate-700 dark:text-slate-300">Adjuntar archivo o guía de la tarea (opcional)</span>
                    </div>
                    <p class="text-[11px] text-slate-500 dark:text-slate-400">Puede adjuntar un PDF, imagen (.png, .jpg) o documento (.docx, .xlsx) directamente al crear la tarea.</p>
                    <input id="file_task" ref="fileTask" type="file" class="block w-full text-xs text-slate-500 file:mr-3 file:py-1.5 file:px-3 file:rounded-xl file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" @change="changeFile('file_task')" accept=".PDF, .PNG, .JPG, .JPEG, .WEBP, .DOC, .DOCX, .XLSX, .PPTX">
                </div>

                <!-- 8. Adjunto al actualizar -->
                <div v-if="rowAction == 'actualizar'" class="p-3.5 bg-slate-50 dark:bg-slate-800/60 rounded-2xl border border-slate-200 dark:border-slate-700">
                    <template v-if="!existeAdjunto">
                        <div class="flex items-center gap-2 mb-1.5">
                            <BaseIcon :path="mdiPaperclip" :size="16" class="text-blue-600" />
                            <span class="text-xs font-bold text-slate-700 dark:text-slate-300">Subir archivo adjunto (opcional)</span>
                        </div>
                        <div v-if="errorMessage" class="mb-2 text-xs font-medium text-red-600">{{ errorMessage }}</div>
                        <input id="file_task_edit" ref="fileTask" type="file" class="block w-full text-xs text-slate-500 file:mr-3 file:py-1.5 file:px-3 file:rounded-xl file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" @change="changeFile('file_task')" accept=".PDF, .PNG, .JPG, .JPEG, .WEBP, .DOC, .DOCX, .XLSX, .PPTX">
                        <BreezeButton class="mt-2.5 !py-1.5 !px-3 !text-xs !rounded-xl" @click="uploadFile('file_task', rowID)" :set="inputFileName = 'TAREA' + rowID">
                            Guardar Adjunto
                        </BreezeButton>
                    </template>
                    <template v-else>
                        <div v-if="filePath && fileName" class="flex items-center justify-between gap-3">
                            <div class="flex items-center gap-2 min-w-0">
                                <BaseIcon :path="mdiPaperclip" :size="16" class="text-blue-600 shrink-0" />
                                <span class="text-xs font-bold text-slate-700 dark:text-slate-300 truncate">{{ fileName }}</span>
                            </div>
                            <div class="flex items-center gap-2 shrink-0">
                                <BaseButton color="info" :icon="mdiDownload" small label="Descargar" :href="route('file-download', { 'srctype': 'file_task', 'srcid': rowID, 'filename': fileName })" target="_blank" />
                                <button type="button" @click="initModal(formTarea.id_file, 'deleteFileTask')" class="text-xs text-red-600 hover:text-red-700 font-semibold underline">Eliminar</button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <!-- Calificación / Retroalimentación docente a respuesta del alumno -->
            <div v-if="rowAction == 'tarearesponse-actualizarresp' || rowAction == 'leer-respuesta'" class="space-y-4">
                <div>
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Título de la respuesta</label>
                    <BreezeInput type="text" class="block w-full rounded-xl text-xs" v-model="formTarea.label" disabled />
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Contenido / Desarrollo del alumno</label>
                    <QuillEditor ref="tareaEditor" style="min-height:100px;" v-model:content="formTarea.description" contentType="html" :toolbar="[]" theme="snow" readOnly />
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Comentario / Retroalimentación al alumno (opcional)</label>
                    <QuillEditor v-if="rowAction == 'leer-respuesta'" ref="tareaEditor" style="min-height:80px;" v-model:content="formTarea.description_collaborator" contentType="html" :toolbar="[]" theme="snow" readOnly />
                    <QuillEditor v-else ref="tareaEditor" style="min-height:80px;" v-model:content="formTarea.description_collaborator" contentType="html" toolbar="essential" theme="snow" placeholder="Escriba aquí sus comentarios..." />
                </div>
                <div v-if="formTarea.is_graded != 0">
                    <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">Calificación (Nota)</label>
                    <BreezeInput id="calification" type="text" class="block w-full rounded-xl text-xs" v-model="formTarea.calification" autocomplete="Nota" :disabled="(rowAction == 'leer-respuesta' ? true : false)" placeholder="Ej: 18" />
                </div>
                <div v-else class="p-3 bg-amber-50 dark:bg-amber-950/30 rounded-xl border border-amber-200 text-xs text-amber-800 dark:text-amber-300 font-semibold">
                    Esta tarea es de tipo Formativa (sin calificación numérica).
                </div>
            </div>
            <!-- Actualizar file -->
            <div v-if="rowAction == 'actualizarFile'">
                <div>
                    <BreezeLabel for="nombre" value="Nombre" />
                    <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="formFile.name" required />
                </div>
                <div>
                    <BreezeLabel for="description" value="Descripción" />
                    <BreezeInput id="description" type="text" class="mt-1 block w-full" v-model="formFile.description" />
                </div>
                <div>
                    <BreezeLabel for="position" value="Posición" />
                    <BreezeInput id="position" type="text" class="mt-1 block w-full" v-model="formFile.position" required />
                </div>
            </div>
            <!-- Actualizar Link -->
            <div v-if="rowAction == 'actualizarLink'">
                <BreezeLabel for="etiqueta" value="Etiqueta" />
                <BreezeInput id="etiqueta" type="text" class="mt-1 block w-full" v-model="formLink.label" required autocomplete="label" />
                <BreezeLabel for="description" value="Descripción" />
                <BreezeInput id="description" type="text" class="mt-1 block w-full" v-model="formLink.description" required autocomplete="false" />
                <BreezeLabel for="url" value="URL" />
                <BreezeInput id="url" type="text" class="mt-1 block w-full" v-model="formLink.url" required autocomplete="true" />

            </div>


        </CardBoxModal>
        <CardBoxModal v-model="isModalDangerActive" title="Por Confirmar" button="danger" hasCancel @confirm="isConfirm" @cancel="isCancel">
            <p>Está seguro de <b>{{ titleModal }}</b></p>
            <p>{{ subTextModal }}</p>
        </CardBoxModal>

        <!-- Modal con vista previa Formulario -->
        <CardBoxModal v-model="isModalFormFullActive" title="Vista previa" sizeModal="formfull" hasCancel>
            <!-- tien el botón de cancelar superior-->
            <div class="grid grid-cols-5 gap-4">
                <div class="col-span-4">
                    <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full">
                </div>
                <div class="col-span-1 grid h-full content-between">
                    <div class="w-full">
                        <div v-if="isErrorForm" class="mb-2">
                            <div class="font-small text-red-600">Ups! Debe registrar la calificación</div>
                        </div>
                        <h2 class="mb-4">Calificación</h2>
                        <input class="rounded-lg w-full mb-3" type="text" v-model="formTarea.calification" placeholder="Nota" @focus="$event.target.select()" :disabled="(rowAction == 'tarearesponse-leerresp-adjunto' ? true : false)">
                        <h2 class="mb-4 mt-4">Comentario (opcional)</h2>
                        <QuillEditor class="rounded-lg w-full mb-3" ref="tareaEditor" style="min-height:20px;" v-model:content="formTarea.description_collaborator" contentType="html" :toolbar="(rowAction == 'tarearesponse-leerresp-adjunto' ? [] : 'essential')" theme="snow" :readOnly="(rowAction == 'tarearesponse-leerresp-adjunto' ? true : false)" />
                        <!-- <input class="rounded-lg w-full mb-3 mt-2" type="text" v-model="formTarea.description_collaborator" placeholder="Comentarios (opcional)" :disabled="(rowAction == 'tarearesponse-leerresp-adjunto' ? true : false)"> -->
                        <!-- <input class="rounded-lg w-full mb-3" type="text" placeholder="Ingresa aqui"> -->
                    </div>
                    <div v-if="rowAction != 'tarearesponse-leerresp-adjunto'" class="w-full flex flex-col">
                        <div>
                            <BaseButton color="success" :icon="mdiCheckBold" small label="Aceptar" class="inline w-full mb-3" @click="isConfirm" />
                        </div>
                        <div>
                            <BaseButton color="danger" :icon="mdiArrowLeftTopBold" small label="Cancelar" class="inline w-full" @click="isCancel, isModalFormFullActive = false" />
                        </div>
                    </div>

                </div>
            </div>
            <!-- w-full es para documetnos w-auto para imágenes-->
            <!-- <div class="flex justify-center w-full">
                <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full">
            </div> -->
        </CardBoxModal>

        <div class="grid gap-4">
            <div class="relative flex flex-col min-w-0 break-words bg-white w-full p-6 min-h-[560px]  rounded-xl shadow-lg">
                <div class="flex-auto ">
                    <div>
                        <!-- Contenido -->
                        <div v-bind:class="{ 'hidden': openTab !== 1, 'block': openTab === 1 }">
                            <ClassroomTopicManager 
                                :idClassroom="classroom.id"
                                :idCourse="course.id"
                                :ciclos="ciclos"
                                :canWrite="canWrite"
                                :refCicloActual="refCicloActual"
                                :studentId="0"
                                :courseName="course.label"
                                :classroomName="classroom.label"
                                :classroomYear="classroom.year"
                                :semanaActual="semanaActual"
                            />
                        </div>
                        <!-- Listado de alumnos -->
                        <div v-bind:class="{ 'hidden': openTab !== 2, 'block': openTab === 2 }">
                            <!-- Lista de estudiantes -->
                            <CardBox v-if="students.length" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableAdvanced modulo="estudiante" :modulos="'Clase ' + classroom.label + ' | ' + course.label" :data="students" :fields="studentCol" ruta="student" exporteable noSearch noPaginate showIndex :numberItems="50" />
                                <!-- visualable checkable -->
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>
                        <!-- Asistencia -->
                        <div v-bind:class="{ 'hidden': openTab !== 3, 'block': openTab === 3 }">
                            <div v-if="!diarios.length || diarios.length != students.length" class="w-full flex justify-start pb-3">
                                <template v-if="canWrite">
                                    <div class="w-full">
                                        <div v-if="diarios.length && diarios.length != students.length" class="mb-2 text-red-600">
                                            <li>La cantidad de registros de asistencia es
                                                distinta a la lista de alumnos de esta aula.
                                            </li>
                                            <li>Click en Iniciar asistencia para crear el
                                                registro del alumno que falta, a menos que sepa
                                                que esta lista es correcta (ej. alumnos
                                                retirados, etc.).</li>
                                        </div>
                                        <div class="flex gap-3 justify-start">
                                            <div>
                                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar asistencia" @click.once="iniciarAsistencia()" />
                                            </div>
                                            <div>
                                                <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" :inertiahref="route('classroomcard-collaborator', { 'id_classroom': classroom.id, 'id_course': course.id, 'can_write': (canWrite ? 1 : 0), 'back_link': back_link })" />
                                            </div>
                                            <!-- <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                                                icon-size="20" small label="Refresh" @click="refreshList(['asistencias'])"/> -->
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-if="diarios.length" class="pb-3 text-xs text-slate-600 dark:text-slate-400 flex flex-col gap-1 bg-slate-50 dark:bg-slate-800/40 p-3 rounded-2xl border border-slate-200/70 dark:border-slate-800">
                                <div class="flex items-center gap-2 font-semibold text-slate-800 dark:text-slate-200">
                                    <Icon icon="tabler:info-circle" class="w-4 h-4 text-indigo-500" />
                                    <span>Control de Asistencia y Reporte Diario de Curso</span>
                                </div>
                                <p class="text-[11px] leading-relaxed">
                                    • La <strong>Asistencia</strong> es general del aula y se guarda automáticamente al cambiar su estado.<br>
                                    • Las <strong>Observaciones, Deméritos y Méritos</strong> son <span class="text-indigo-600 dark:text-indigo-400 font-bold underline">exclusivos de este curso ({{ course.label }})</span> y se guardan en la agenda escolar al presionar el botón <strong>Guardar</strong> de su sección.
                                </p>
                            </div>
                            <div v-if="diarios.length" class="overflow-x-auto w-full pb-3 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900/60 shadow-xs">
                                <table class="table-responsive w-full min-w-[980px]">
                                    <thead>
                                        <!-- NIVEL 1: Agrupación de Secciones -->
                                        <tr class="text-xs">
                                            <th colspan="3" class="py-2 px-3 text-left font-bold text-slate-600 dark:text-slate-300 bg-slate-100/80 dark:bg-slate-800/80 border-b border-r border-slate-200 dark:border-slate-700">
                                                <div class="flex items-center gap-1.5">
                                                    <Icon icon="tabler:calendar-check" class="w-4 h-4 text-emerald-600" />
                                                    <span>Asistencia General del Aula</span>
                                                    <span class="text-[10px] font-normal text-slate-400">(Compartida en todos los cursos)</span>
                                                </div>
                                            </th>
                                            <th colspan="4" class="py-2 px-3 text-left font-bold text-indigo-900 dark:text-indigo-200 bg-gradient-to-r from-indigo-50 via-purple-50 to-indigo-50 dark:from-indigo-950/60 dark:via-purple-950/40 dark:to-indigo-950/60 border-b border-l-2 border-r border-indigo-300 dark:border-indigo-700">
                                                <div class="flex items-center justify-between gap-2 flex-wrap">
                                                    <div class="flex items-center gap-1.5">
                                                        <Icon icon="tabler:book" class="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                                                        <span>Reporte Exclusivo de este Curso: <u>{{ course.label }}</u></span>
                                                    </div>
                                                    <span class="px-2 py-0.5 rounded-full bg-indigo-600 text-white font-bold text-[10px] uppercase tracking-wider shadow-2xs">
                                                        Sólo su curso
                                                    </span>
                                                </div>
                                            </th>
                                            <th class="w-12 text-center py-2 px-1 text-slate-400 bg-slate-100/80 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700 text-[11px]">
                                                Info
                                            </th>
                                        </tr>
                                        <!-- NIVEL 2: Columnas individuales -->
                                        <tr class="text-xs border-b border-slate-200 dark:border-slate-700">
                                            <th class="w-10 text-center py-2 bg-slate-50 dark:bg-slate-800/50 text-slate-500">#</th>
                                            <th class="w-44 py-2 bg-slate-50 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300">Estudiante</th>
                                            <th class="w-72 py-2 bg-slate-50 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300 border-r border-slate-200 dark:border-slate-700">Asistencia</th>
                                            <th class="w-48 py-2 bg-indigo-50/70 dark:bg-indigo-950/40 text-indigo-900 dark:text-indigo-200 border-l-2 border-indigo-300 dark:border-indigo-700 font-bold">
                                                Observaciones (Curso)
                                            </th>
                                            <th class="w-40 py-2 bg-indigo-50/70 dark:bg-indigo-950/40 text-rose-700 dark:text-rose-400 font-bold">
                                                Demérito (Curso)
                                            </th>
                                            <th class="w-40 py-2 bg-indigo-50/70 dark:bg-indigo-950/40 text-emerald-700 dark:text-emerald-400 font-bold">
                                                Mérito (Curso)
                                            </th>
                                            <th v-if="canWrite" class="w-16 text-center py-2 bg-indigo-50/70 dark:bg-indigo-950/40 text-indigo-900 dark:text-indigo-200 border-r border-indigo-200 dark:border-indigo-800 font-bold">
                                                Guardar
                                            </th>
                                            <th class="w-12 text-center py-2 bg-slate-50 dark:bg-slate-800/50 text-slate-400">Log</th>
                                        </tr>
                                    </thead>
                                    <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                        <tr v-for="(diario, index) in diarios" :key="diario.id" class="border-b border-slate-100 dark:border-slate-800 hover:bg-slate-50/40 dark:hover:bg-slate-800/40 transition">
                                            <td data-label="#" class="text-center font-bold text-xs text-slate-500">{{ index + 1 }}</td>
                                            <td class="flex justify-start lg:table-cell bg-gray-100 lg:bg-transparent font-bold text-xs" data-label="Estudiante">
                                                {{ diario.apellidos + ' ' + diario.nombres }}
                                            </td>
                                            <td class="flex justify-start lg:table-cell border-r border-slate-200 dark:border-slate-700" data-label="Asistencia">
                                                <div class="inline-flex items-center rounded-xl bg-slate-100 dark:bg-slate-800 p-1 gap-1 border border-slate-200/80 dark:border-slate-700">
                                                    <label :class="diario.asistencia == 1 ? 'bg-emerald-600 text-white font-bold shadow-xs' : 'text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700'" class="px-2 py-1 rounded-lg text-xs cursor-pointer transition flex items-center gap-1 select-none" title="Asistencia">
                                                        <input type="radio" value="1" v-model="diario.asistencia" class="sr-only" :name="'n-radio' + diario.id" @change="onAttendanceChange(diario)">
                                                        <span class="w-1.5 h-1.5 rounded-full" :class="diario.asistencia == 1 ? 'bg-white' : 'bg-emerald-500'"></span>
                                                        <span>Asistió</span>
                                                    </label>
                                                    <label :class="diario.asistencia == 0 ? 'bg-rose-600 text-white font-bold shadow-xs' : 'text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700'" class="px-2 py-1 rounded-lg text-xs cursor-pointer transition flex items-center gap-1 select-none" title="Falta">
                                                        <input type="radio" value="0" v-model="diario.asistencia" class="sr-only" :name="'n-radio' + diario.id" @change="onAttendanceChange(diario)">
                                                        <span class="w-1.5 h-1.5 rounded-full" :class="diario.asistencia == 0 ? 'bg-white' : 'bg-rose-500'"></span>
                                                        <span>Falta</span>
                                                    </label>
                                                    <label :class="diario.asistencia == 3 ? 'bg-rose-700 text-white font-bold shadow-xs' : 'text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700'" class="px-1.5 py-1 rounded-lg text-xs cursor-pointer transition flex items-center gap-1 select-none" title="Falta Justificada">
                                                        <input type="radio" value="3" v-model="diario.asistencia" class="sr-only" :name="'n-radio' + diario.id" @change="onAttendanceChange(diario)">
                                                        <span>F. Just.</span>
                                                    </label>
                                                    <label :class="diario.asistencia == 2 ? 'bg-amber-500 text-white font-bold shadow-xs' : 'text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700'" class="px-2 py-1 rounded-lg text-xs cursor-pointer transition flex items-center gap-1 select-none" title="Tardanza">
                                                        <input type="radio" value="2" v-model="diario.asistencia" class="sr-only" :name="'n-radio' + diario.id" @change="onAttendanceChange(diario)">
                                                        <span class="w-1.5 h-1.5 rounded-full" :class="diario.asistencia == 2 ? 'bg-white' : 'bg-amber-500'"></span>
                                                        <span>Tardanza</span>
                                                    </label>
                                                    <label :class="diario.asistencia == 4 ? 'bg-amber-600 text-white font-bold shadow-xs' : 'text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700'" class="px-1.5 py-1 rounded-lg text-xs cursor-pointer transition flex items-center gap-1 select-none" title="Tardanza Justificada">
                                                        <input type="radio" value="4" v-model="diario.asistencia" class="sr-only" :name="'n-radio' + diario.id" @change="onAttendanceChange(diario)">
                                                        <span>T. Just.</span>
                                                    </label>
                                                </div>
                                            </td>
                                            <!-- SECCIÓN EXCLUSIVA DEL CURSO (Observaciones, Demérito, Mérito y Acción) -->
                                            <td class="lg:table-cell bg-indigo-50/25 dark:bg-indigo-950/20 border-l-2 border-indigo-300 dark:border-indigo-700" data-label="Observaciones (Curso)">
                                                <input type="text" v-model="diario.observation_course" :placeholder="'Obs. sólo ' + course.label + '...'" class="w-full text-xs rounded-xl border-indigo-200 dark:border-indigo-800/70 dark:bg-slate-800 py-1.5 px-2.5 focus:border-indigo-500" :title="'Observación exclusiva para el curso ' + course.label">
                                            </td>
                                            <td class="lg:table-cell bg-indigo-50/25 dark:bg-indigo-950/20" data-label="Demérito (Sólo su curso)">
                                                <div class="flex flex-col gap-1 w-full min-w-[130px]">
                                                    <input type="text" v-model="diario.demerit_code" placeholder="Cód. Demérito" class="w-full rounded-lg text-xs py-1 px-2 font-bold text-rose-600 dark:text-rose-400 bg-rose-50/80 dark:bg-rose-950/30 border-rose-200 dark:border-rose-900/50">
                                                    <input type="text" v-model="diario.demerits" placeholder="Motivo" class="w-full rounded-lg text-xs py-1 px-2 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-700">
                                                </div>
                                            </td>
                                            <td class="lg:table-cell bg-indigo-50/25 dark:bg-indigo-950/20" data-label="Mérito (Sólo su curso)">
                                                <div class="flex flex-col gap-1 w-full min-w-[130px]">
                                                    <input type="text" v-model="diario.merit_code" placeholder="Cód. Mérito" class="w-full rounded-lg text-xs py-1 px-2 font-bold text-emerald-600 dark:text-emerald-400 bg-emerald-50/80 dark:bg-emerald-950/30 border-emerald-200 dark:border-emerald-900/50">
                                                    <input type="text" v-model="diario.merits" placeholder="Motivo" class="w-full rounded-lg text-xs py-1 px-2 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-700">
                                                </div>
                                            </td>
                                            <td v-if="canWrite" class="flex lg:table-cell text-center bg-indigo-50/25 dark:bg-indigo-950/20 border-r border-indigo-200/70 dark:border-indigo-800/60" data-label="Acción">
                                                <button type="button" @click="saveCourseAgendaRecord(diario)" class="p-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition shadow-xs inline-flex items-center justify-center" :title="'Guardar reporte exclusivo de ' + course.label">
                                                    <Icon icon="tabler:device-floppy" class="w-4 h-4" />
                                                </button>
                                            </td>
                                            <td data-label="Log" @click="showLog = !showLog" class="text-center cursor-pointer">
                                                <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                <span class="text-[11px] block text-slate-400" v-if="showLog">{{ diario.nombre_usuario }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else>
                                <p>
                                    Iniciar asistencia, marcar todos como presentes
                                    (Asistencia), click
                                    en Refresh si no ve la lista luego de iniciar la asistencia
                                    ...
                                </p>
                            </div>
                        </div>
                        <!-- Tareas -->
                        <div v-bind:class="{ 'hidden': openTab !== 4, 'block': openTab === 4 }">
                            <div v-if="canWrite" id="sectiontarea">
                                <a href="#sectiontarea" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['tareas'] = !showAyuda['tareas']">
                                    Ayuda
                                    <BaseIcon :path="mdiInformationOutline" size="15" />
                                </a>
                                <fieldset v-if="showAyuda['tareas']" class="border border-gray-300 p-4 rounded-md mb-6">
                                    <legend class="text-lg font-bold px-2">1</legend>
                                    <ul>
                                        <li>Puede crear tareas para distintos Bimestres, se
                                            establece por
                                            defecto el bimestre actual y en borrador, puede publicar
                                            la
                                            tarea cuando lo desee para que los alumnos la vean.</li>
                                        <li>Al editar la tarea puede adjuntar archivo si fuera
                                            necesario.
                                            Puede adjuntar cualquier tipo de documento, pero la
                                            vista previa
                                            sólo está disponible para imagen y PDF.</li>
                                        <li>Cuando los alumnos publiquen sus respuestas podrá
                                            editarlas
                                            registrando la nota o algún mensaje opcional. El alumno
                                            no podrá
                                            modificar su repuesta de la tarea cuando ya la publicó.
                                        </li>
                                        <li>Usted puede volver a borrador una respuesta ya publicada
                                            del
                                            alumno, luego esta desaparecerá de su lista de
                                            respuestas y el
                                            alumno podrá modificarla para volverla a publicar.</li>
                                    </ul>
                                </fieldset>
                            </div>
                            <div v-if="canWrite" class="w-full flex justify-start gap-3">
                                <div>
                                    <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Nueva tarea" @click="initModal('', 'registrar')" />
                                </div>
                                <div>
                                    <BaseButton :icon="mdiRefresh" color="info" icon-size="20" small label="Refresh" @click="refresh()" />
                                </div>
                            </div>

                            <div v-if="tasks.length" class="mb-24 mt-4 space-y-4" :set="respuestas = []">
                                <div class="flex items-center justify-between px-1">
                                    <div class="flex items-center gap-2">
                                        <BaseIcon :path="mdiBookOpenVariant" :size="20" class="text-indigo-600" />
                                        <h3 class="font-black text-base text-slate-800 dark:text-white">Tareas del Curso</h3>
                                        <span class="text-xs font-bold px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                                            {{ tasks.length }}
                                        </span>
                                    </div>
                                </div>

                                <div 
                                    v-for="(task, index) in tasks" 
                                    :key="task.id" 
                                    :set="respuestas[index] = taskResponses.filter(item => item.id_task == task.id)" 
                                    class="relative bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-xs transition-all hover:border-slate-300 dark:hover:border-slate-700 hover:z-20 focus-within:z-30"
                                >
                                    <!-- Cabecera de la Tarea -->
                                    <div 
                                        :class="[
                                            'p-4 sm:p-5 flex flex-col lg:flex-row lg:items-center justify-between gap-3 bg-gradient-to-b from-white to-slate-50/50 dark:from-slate-900 dark:to-slate-900/80',
                                            showResp[index] ? 'rounded-t-2xl border-b border-slate-100 dark:border-slate-800' : 'rounded-2xl'
                                        ]"
                                    >
                                        <div class="space-y-2 flex-1 min-w-0">
                                            <!-- Badges de la tarea -->
                                            <div class="flex flex-wrap items-center gap-1.5 text-[11px]">
                                                <!-- Bimestre -->
                                                <span class="font-black px-2.5 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border border-slate-200/70 dark:border-slate-700">
                                                    {{ task.ref_ciclo }}
                                                </span>

                                                <!-- Estado Publicado / Borrador -->
                                                <span 
                                                    :class="[
                                                        'font-bold px-2.5 py-0.5 rounded-lg border flex items-center gap-1',
                                                        task.status 
                                                            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900/50' 
                                                            : 'bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700'
                                                    ]"
                                                >
                                                    <span class="w-1.5 h-1.5 rounded-full" :class="task.status ? 'bg-emerald-500' : 'bg-slate-400'"></span>
                                                    <span>{{ task.status ? 'Publicado' : 'Borrador' }}</span>
                                                </span>

                                                <!-- Modalidad de entrega: Digital vs Física -->
                                                <span 
                                                    :class="[
                                                        'font-bold px-2.5 py-0.5 rounded-lg border flex items-center gap-1',
                                                        task.delivery_type === 'fisico' 
                                                            ? 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-900/50' 
                                                            : 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-900/50'
                                                    ]"
                                                >
                                                    <BaseIcon :path="task.delivery_type === 'fisico' ? mdiBook : mdiCloudUploadOutline" :size="13" />
                                                    <span>{{ task.delivery_type === 'fisico' ? 'Recepción Física' : 'Entrega Digital' }}</span>
                                                </span>

                                                <!-- Tipo de Evaluación: Calificada vs Formativa -->
                                                <span 
                                                    v-if="task.is_graded == 0"
                                                    class="font-bold px-2.5 py-0.5 rounded-lg border bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900/50"
                                                    title="Tarea formativa sin calificación numérica"
                                                >
                                                    Formativa (Sin nota)
                                                </span>

                                                <!-- Adjunto si existe -->
                                                <a 
                                                    v-if="task.id_file" 
                                                    :href="route('file-download', { 'srctype': 'file_task', 'srcid': task.id, 'filename': task.filename })" 
                                                    target="_blank"
                                                    class="font-bold px-2.5 py-0.5 rounded-lg border bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-900/50 flex items-center gap-1 transition-colors"
                                                    title="Descargar material adjunto"
                                                >
                                                    <BaseIcon :path="mdiPaperclip" :size="13" />
                                                    <span>Guía / Adjunto</span>
                                                </a>
                                            </div>

                                            <!-- Título de la tarea -->
                                            <h4 class="text-sm sm:text-base font-bold text-slate-800 dark:text-white leading-snug">
                                                {{ task.label }}
                                            </h4>

                                            <!-- Metadatos de Fecha y Respuestas -->
                                            <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500 dark:text-slate-400">
                                                <div class="flex items-center gap-1">
                                                    <span class="font-semibold text-slate-700 dark:text-slate-300">Publicado:</span>
                                                    <span>{{ formatDate(task.start_date) || '-' }}</span>
                                                </div>
                                                <div class="flex items-center gap-1">
                                                    <span class="font-semibold text-slate-700 dark:text-slate-300">Finaliza:</span>
                                                    <span :class="task.end_date ? 'font-medium' : 'italic text-slate-400'">
                                                        {{ task.end_date ? formatDateTime(task.end_date) : 'Sin fecha límite' }}
                                                    </span>
                                                </div>
                                                <div class="flex items-center gap-1.5">
                                                    <span class="font-semibold text-slate-700 dark:text-slate-300">Respuestas:</span>
                                                    <span class="px-2 py-0.2 rounded-md font-bold text-[11px]" :class="respuestas[index].length > 0 ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'">
                                                        {{ respuestas[index].length }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Acciones Rápidas -->
                                        <div class="flex items-center gap-2 shrink-0 pt-2 lg:pt-0 border-t lg:border-t-0 border-slate-100 dark:border-slate-800">
                                            <!-- Botón Toggle de Respuestas -->
                                            <button 
                                                type="button" 
                                                @click="showResp[index] = !showResp[index]"
                                                class="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-bold transition-all"
                                                :class="showResp[index] ? 'bg-indigo-600 text-white shadow-xs' : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'"
                                                title="Ver / Ocultar respuestas"
                                            >
                                                <BaseIcon :path="mdiMenu" :size="15" />
                                                <span>{{ showResp[index] ? 'Ocultar' : 'Respuestas' }} ({{ respuestas[index].length }})</span>
                                            </button>

                                            <!-- Ver detalle tarea -->
                                            <BaseButton v-if="!canWrite" color="info" :icon="mdiEye" small @click="initModal(task.id, 'leer', task)" title="Ver tarea" />

                                            <!-- Editar tarea -->
                                            <BaseButton v-if="canWrite" color="warning" :icon="mdiPencil" small title="Editar tarea" @click="initModal(task.id, 'actualizar', task)" />

                                            <!-- Menú desplegable de opciones -->
                                            <div class="inline-block">
                                                <BreezeDropdown align="right" width="48" :content-classes="['py-1', 'bg-white', 'dark:bg-slate-800', 'border', 'border-slate-200/80', 'dark:border-slate-700', 'shadow-xl']">
                                                    <template #trigger>
                                                        <button type="button" title="Más opciones" class="inline-flex items-center p-2 rounded-xl text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition">
                                                            <BaseIcon :path="mdiDotsVertical" :size="16" />
                                                        </button>
                                                    </template>
                                                    <template #content>
                                                        <template v-if="canWrite">
                                                            <BreezeDropdownOption v-if="task.status" @click="initModal(task.id, 'borrador')">
                                                                Volver a Borrador
                                                            </BreezeDropdownOption>
                                                            <BreezeDropdownOption v-else @click="initModal(task.id, 'publicar')">
                                                                Publicar tarea
                                                            </BreezeDropdownOption>
                                                        </template>
                                                        <BreezeDropdownOption v-if="task.id_file" @click="(isModalFullActive = true, modalFullSrc = '/documents/' + task.filepath + '/' + task.filename)">
                                                            Ver adjunto
                                                        </BreezeDropdownOption>
                                                        <BreezeDropdownOption v-if="task.id_file" :href="route('file-download', { 'srctype': 'file_task', 'srcid': task.id, 'filename': task.filename })" target="_blank">
                                                            Descargar adjunto
                                                        </BreezeDropdownOption>
                                                        <BreezeDropdownOption v-if="task.id_file && canWrite" @click="initModal(task.id_file, 'deleteFileTask')">
                                                            Eliminar adjunto
                                                        </BreezeDropdownOption>
                                                        <BreezeDropdownOption v-if="!task.id_file && canWrite && !task.status" @click="initModal(task.id, 'deleteTask')">
                                                            Eliminar tarea
                                                        </BreezeDropdownOption>
                                                    </template>
                                                </BreezeDropdown>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Panel desplegable de Respuestas -->
                                    <div v-if="showResp[index]" class="p-4 sm:p-5 bg-slate-50/70 dark:bg-slate-900/40 border-t border-slate-100 dark:border-slate-800 space-y-3 rounded-b-2xl">
                                        <!-- Aviso cuando es Tarea Física -->
                                        <div v-if="task.delivery_type === 'fisico'" class="p-3.5 rounded-xl bg-purple-50 dark:bg-purple-950/30 border border-purple-200/70 dark:border-purple-900/40 flex items-start gap-2.5 text-xs text-purple-900 dark:text-purple-200">
                                            <BaseIcon :path="mdiBook" :size="18" class="text-purple-600 shrink-0 mt-0.5" />
                                            <div>
                                                <strong class="font-bold">Recepción Física en Aula:</strong>
                                                <span class="ml-1">Los estudiantes desarrollan esta tarea en su cuaderno u hojas de trabajo. No se exige entrega digital en la plataforma.</span>
                                            </div>
                                        </div>

                                        <!-- Tabla de Respuestas en Desktop -->
                                        <div v-if="respuestas[index].length" class="hidden md:block overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
                                            <table class="w-full text-left text-xs">
                                                <thead class="bg-slate-50 dark:bg-slate-800/80 text-[11px] uppercase font-bold text-slate-500 dark:text-slate-400 border-b border-slate-200 dark:border-slate-700">
                                                    <tr>
                                                        <th class="py-3 px-4 w-12 text-center">#</th>
                                                        <th class="py-3 px-4">Estudiante / Respuesta</th>
                                                        <th class="py-3 px-4">F. Publicación</th>
                                                        <th class="py-3 px-4 text-center">Nota</th>
                                                        <th class="py-3 px-4 text-right">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="divide-y divide-slate-100 dark:divide-slate-700/60">
                                                    <tr v-for="(resp, index2) in respuestas[index]" :key="resp.id" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/30 transition-colors">
                                                        <td class="py-3 px-4 text-center font-bold text-slate-400">{{ index2 + 1 }}</td>
                                                        <td class="py-3 px-4">
                                                            <div class="font-bold text-slate-800 dark:text-white">{{ resp.apellidos + ' ' + resp.nombres }}</div>
                                                            <div class="text-[11px] text-slate-500 dark:text-slate-400 truncate max-w-xs">{{ resp.label }}</div>
                                                        </td>
                                                        <td class="py-3 px-4 whitespace-nowrap text-slate-600 dark:text-slate-300" :class="(task.end_date && resp.end_date > task.end_date ? 'text-rose-600 font-bold' : '')">
                                                            {{ resp.end_date }}
                                                        </td>
                                                        <td class="py-3 px-4 text-center whitespace-nowrap">
                                                            <span v-if="task.is_graded == 0" class="px-2 py-0.5 rounded-lg text-[10px] font-bold bg-amber-50 text-amber-700 border border-amber-200">
                                                                Formativa
                                                            </span>
                                                            <span 
                                                                v-else-if="resp.calification !== null && resp.calification !== undefined"
                                                                :class="[
                                                                    'px-2.5 py-1 rounded-lg text-xs font-black inline-block',
                                                                    parseInt(resp.calification) >= 11 
                                                                        ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300 border border-emerald-200' 
                                                                        : 'bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 border border-rose-200'
                                                                ]"
                                                            >
                                                                {{ parseInt(resp.calification) }}
                                                            </span>
                                                            <span v-else class="text-slate-400 font-normal">-</span>
                                                        </td>
                                                        <td class="py-3 px-4 text-right whitespace-nowrap">
                                                            <div class="inline-flex items-center gap-1.5 justify-end">
                                                                <template v-if="canWrite">
                                                                    <BaseButton color="warning" :icon="mdiPencil" small @click="initModal(resp.id, 'tarearesponse-actualizarresp', resp)" title="Calificar / Comentar" label="R" />
                                                                    <BaseButton v-if="resp.id_file" color="warning" :icon="mdiPaperclip" small @click="initModal(resp.id, 'tarearesponse-actualizarresp-adjunto', resp)" title="Revisar con Adjunto" label="RA" />
                                                                    <BaseButton v-if="resp.id_file" color="info" :icon="mdiDownload" small title="Descargar Adjunto" :href="route('file-download', { 'srctype': 'file_taskresp', 'srcid': resp.id, 'filename': resp.filename })" target="_blank" />
                                                                    <BaseButton v-if="resp.status" color="success" :icon="mdiCheckCircle" small @click="initModal(resp.id, 'tarearesponse-borrador')" title="Publicado (click para pasar a borrador)" />
                                                                    <BaseButton v-else color="contrast" :icon="mdiCloseCircle" small @click="initModal(resp.id, 'publicar')" title="Borrador" />
                                                                </template>
                                                                <template v-else>
                                                                    <BaseButton color="info" :icon="mdiEye" @click="initModal(resp.id, 'leer-respuesta', resp)" small title="Ver Respuesta" label="R" />
                                                                    <BaseButton v-if="resp.id_file" color="info" :icon="mdiPaperclip" small @click="initModal(resp.id, 'tarearesponse-leerresp-adjunto', resp)" title="Ver con Adjunto" label="RA" />
                                                                    <BaseButton v-if="resp.id_file" color="info" :icon="mdiDownload" small title="Descargar Adjunto" :href="route('file-download', { 'srctype': 'file_taskresp', 'srcid': resp.id, 'filename': resp.filename })" target="_blank" />
                                                                </template>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Vista Móvil de Respuestas (Cards amigables) -->
                                        <div v-if="respuestas[index].length" class="block md:hidden space-y-2.5">
                                            <div 
                                                v-for="(resp, index2) in respuestas[index]" 
                                                :key="'mob-' + resp.id"
                                                class="p-3.5 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-xs space-y-2"
                                            >
                                                <div class="flex items-start justify-between gap-2">
                                                    <div>
                                                        <div class="font-bold text-xs text-slate-800 dark:text-white">
                                                            {{ index2 + 1 }}. {{ resp.apellidos + ' ' + resp.nombres }}
                                                        </div>
                                                        <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">
                                                            {{ resp.label }}
                                                        </div>
                                                    </div>
                                                    <span 
                                                        v-if="task.is_graded != 0 && resp.calification !== null && resp.calification !== undefined"
                                                        :class="[
                                                            'px-2 py-0.5 rounded-lg text-xs font-black shrink-0',
                                                            parseInt(resp.calification) >= 11 
                                                                ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' 
                                                                : 'bg-rose-50 text-rose-700 border border-rose-200'
                                                        ]"
                                                    >
                                                        Nota: {{ parseInt(resp.calification) }}
                                                    </span>
                                                    <span v-else-if="task.is_graded == 0" class="text-[10px] font-bold px-2 py-0.5 rounded-lg bg-amber-50 text-amber-700 border border-amber-200">
                                                        Formativa
                                                    </span>
                                                </div>

                                                <div class="flex items-center justify-between text-[11px] text-slate-400 pt-1 border-t border-slate-100 dark:border-slate-700">
                                                    <span>{{ resp.end_date }}</span>
                                                    <div class="flex items-center gap-1">
                                                        <BaseButton v-if="canWrite" color="warning" :icon="mdiPencil" small @click="initModal(resp.id, 'tarearesponse-actualizarresp', resp)" title="Calificar" label="R" />
                                                        <BaseButton v-if="resp.id_file" color="warning" :icon="mdiPaperclip" small @click="initModal(resp.id, 'tarearesponse-actualizarresp-adjunto', resp)" title="Ver Adjunto" label="RA" />
                                                        <BaseButton v-if="resp.id_file" color="info" :icon="mdiDownload" small title="Descargar" :href="route('file-download', { 'srctype': 'file_taskresp', 'srcid': resp.id, 'filename': resp.filename })" target="_blank" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Estado cuando no hay respuestas -->
                                        <div v-else class="p-6 text-center bg-white dark:bg-slate-800 rounded-xl border border-dashed border-slate-200 dark:border-slate-700">
                                            <p class="text-xs text-slate-500 dark:text-slate-400 font-medium">
                                                {{ task.delivery_type === 'fisico' ? 'Sin registros digitales para esta tarea física (revisión directa en cuaderno).' : 'Aún no hay respuestas registradas por los alumnos para esta tarea.' }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="mt-4 p-8 text-center bg-slate-50 dark:bg-slate-800/40 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700">
                                <BaseIcon :path="mdiBookOpenVariant" :size="32" class="text-slate-400 mx-auto mb-2" />
                                <h4 class="text-sm font-bold text-slate-700 dark:text-slate-300">Sin tareas registradas</h4>
                                <p class="text-xs text-slate-400 mt-1">Cree una nueva tarea física o digital para este curso.</p>
                            </div>
                        </div>
                        <!-- Recursos de estudio -->
                        <div v-bind:class="{ 'hidden': openTab !== 5, 'block': openTab === 5 }" class="grid gap-4">
                            <div>
                                <!-- <p class="p-4">Listado de recursos del maestro</p> -->
                                <div v-if="canWrite">
                                    <!-- <div class="mb-3">
                                                                <span @click="showInputFile = !showInputFile">[ +
                                                                    Agregar
                                                                    recursos de
                                                                    estudio]</span>
                                                            </div> -->
                                    <div>
                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Nuevo recurso de estudio" @click="showInputFile = !showInputFile" />
                                    </div>
                                    <div v-if="showInputFile" class="mt-4 border border-gray-200 rounded-lg shadow-sm bg-white overflow-hidden">
                                        <!-- Header con selector de tipo -->
                                        <div class="bg-gray-50 border-b border-gray-200 p-3 flex items-center justify-between">
                                            <span class="text-sm font-semibold text-gray-700">Nuevo recurso</span>
                                            <select v-model="resourceTypeLink">
                                                <option :value="false" selected>Tipo Adjunto</option>
                                                <option :value="true">Tipo Link</option>
                                            </select>
                                        </div>

                                        <!-- Formulario Tipo Adjunto -->
                                        <div v-if="!resourceTypeLink" class="p-4 space-y-4">
                                            <div class="flex items-center gap-2 bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900/50 rounded-xl px-4 py-3">
                                                <BaseIcon :path="mdiInformationOutline" size="18" class="text-blue-500 shrink-0" />
                                                <p class="text-xs text-blue-700 dark:text-blue-300 leading-relaxed">
                                                    Puede subir <b>uno o varios archivos</b> (PDF, DOCX, PPT, XLSX, JPG, PNG). Límite de <b>{{ confGlobal.value.RESOURCE_LIMIT_UPLOAD_FILE || 5000 }} KB</b> por archivo. Al seleccionar varios archivos, cada uno se guardará con su propio nombre. Si un archivo con el mismo nombre ya existe, será reemplazado.
                                                </p>
                                            </div>

                                            <div class="flex items-center justify-center w-full">
                                                <label for="file_resource" class="flex flex-col items-center justify-center w-full py-6 sm:py-8 border-2 border-dashed rounded-2xl cursor-pointer transition" :class="fileSize > (1000 * parseInt(confGlobal.value.RESOURCE_LIMIT_UPLOAD_FILE || 5000)) ? 'bg-red-50 border-red-300 hover:bg-red-100' : 'bg-slate-50 border-slate-300 hover:bg-slate-100 dark:bg-slate-900/50 dark:border-slate-700 dark:hover:bg-slate-900'">
                                                    <div class="flex flex-col items-center justify-center p-3 text-center">
                                                        <template v-if="selectedFileName && fileSize > (1000 * parseInt(confGlobal.value.RESOURCE_LIMIT_UPLOAD_FILE || 5000))">
                                                            <BaseIcon :path="mdiCloseCircle" size="32" class="text-red-500 shrink-0 mb-1" />
                                                            <p class="text-sm text-red-600 font-semibold">Uno o más archivos superan el tamaño límite permitido</p>
                                                            <p class="text-xs text-red-400 mt-0.5">Click para seleccionar otros archivos</p>
                                                        </template>
                                                        <template v-else-if="selectedFilesList.length > 0">
                                                            <div class="w-12 h-12 rounded-2xl bg-emerald-100 text-emerald-600 dark:bg-emerald-950/50 dark:text-emerald-300 flex items-center justify-center mb-2 shadow-2xs">
                                                                <BaseIcon :path="mdiCheckDecagram" :size="26" />
                                                            </div>
                                                            <p class="text-sm font-bold text-slate-800 dark:text-white">
                                                                {{ selectedFilesList.length === 1 ? selectedFilesList[0].name : selectedFilesList.length + ' archivos seleccionados' }}
                                                            </p>
                                                            <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Click para cambiar o seleccionar más archivos</p>
                                                        </template>
                                                        <template v-else>
                                                            <div class="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 dark:bg-blue-950/40 dark:text-blue-300 flex items-center justify-center mb-2">
                                                                <BaseIcon :path="mdiCloudUploadOutline" :size="26" />
                                                            </div>
                                                            <p class="text-sm font-semibold text-slate-700 dark:text-slate-200">
                                                                Click para seleccionar uno o varios archivos
                                                            </p>
                                                            <p class="text-xs text-slate-400 mt-1">PDF, DOCX, PPT, XLSX, JPG, PNG (Máx. {{ confGlobal.value.RESOURCE_LIMIT_UPLOAD_FILE || 5000 }} KB por archivo)</p>
                                                        </template>
                                                    </div>
                                                    <input id="file_resource" ref="fileResource" type="file" multiple @change="changeFile('file_resource')" class="hidden" accept=".PDF, .PNG, .JPG, .JPEG, .WEBP, .DOC, .DOCX, .PPT, .PPTX, .XLSX, .XLS">
                                                </label>
                                            </div>

                                            <!-- Previsualización de archivos seleccionados -->
                                            <div v-if="selectedFilesList.length > 0" class="p-3.5 bg-slate-50 dark:bg-slate-900/60 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2">
                                                <div class="flex items-center justify-between text-xs text-slate-600 dark:text-slate-300">
                                                    <span class="font-bold">Archivos a subir ({{ selectedFilesList.length }}):</span>
                                                    <span class="text-[11px] text-slate-400">Cada archivo se registrará con su nombre original</span>
                                                </div>
                                                <div class="flex flex-wrap gap-2 max-h-36 overflow-y-auto pr-1">
                                                    <div 
                                                        v-for="(f, i) in selectedFilesList" 
                                                        :key="i" 
                                                        class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-xs shadow-2xs"
                                                    >
                                                        <BaseIcon :path="mdiPaperclip" :size="14" class="text-blue-500 shrink-0" />
                                                        <span class="font-medium text-slate-800 dark:text-slate-200 truncate max-w-[220px]" :title="f.name">{{ f.name }}</span>
                                                        <span class="text-[10px] text-slate-400 font-mono">({{ (f.size / 1024).toFixed(0) }} KB)</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <BreezeLabel for="inputname" :value="selectedFilesList.length > 1 ? 'Nombre (automático por archivo)' : 'Nombre'" :required="selectedFilesList.length <= 1" />
                                                    <BreezeInput 
                                                        id="inputname" 
                                                        type="text" 
                                                        class="mt-1 block w-full rounded-xl" 
                                                        v-model="inputFileName" 
                                                        :disabled="selectedFilesList.length > 1"
                                                        :placeholder="selectedFilesList.length > 1 ? 'Se guardará con el nombre de cada archivo' : 'Nombre del recurso'" 
                                                        :required="selectedFilesList.length <= 1" 
                                                    />
                                                    <p v-if="selectedFilesList.length > 1" class="text-[11px] text-slate-500 mt-1 italic">
                                                        Al subir múltiples archivos, cada uno se registrará automáticamente con su propio nombre.
                                                    </p>
                                                </div>
                                                <div>
                                                    <BreezeLabel for="pos" value="Posición" />
                                                    <BreezeInput id="inputpos" type="number" class="mt-1 block w-full rounded-xl" v-model="inputFilePos" />
                                                </div>
                                            </div>
                                            <div>
                                                <BreezeLabel for="desc" value="Descripción (opcional)" />
                                                <BreezeInput id="inputdesc" type="text" class="mt-1 block w-full rounded-xl" v-model="inputFileDesc" placeholder="Descripción opcional" />
                                            </div>

                                            <div class="flex justify-end pt-2 border-t border-gray-100 dark:border-slate-800">
                                                <BaseButton 
                                                    :icon="mdiPlusCircle" 
                                                    color="info" 
                                                    icon-size="20" 
                                                    small 
                                                    :label="isUploadingFile ? 'Subiendo...' : (selectedFilesList.length > 1 ? 'Guardar ' + selectedFilesList.length + ' recursos' : 'Guardar')" 
                                                    :disabled="isUploadingFile"
                                                    @click="uploadFile('file_resource')" 
                                                />
                                            </div>
                                        </div>

                                        <!-- Formulario Tipo Link -->
                                        <div v-else class="p-3 space-y-4">
                                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <BreezeLabel for="inputname" value="Nombre" required />
                                                    <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="formLink.label" required />
                                                </div>
                                                <div>
                                                    <BreezeLabel for="inputdescription" value="Descripción" required />
                                                    <BreezeInput id="inputdescription" type="text" class="mt-1 block w-full" v-model="formLink.description" required />
                                                </div>
                                            </div>
                                            <div>
                                                <BreezeLabel for="url" value="URL" />
                                                <BreezeInput id="url" type="text" class="mt-1 block w-full" v-model="formLink.url" required placeholder="Debe iniciar con https://..." />
                                            </div>
                                            <div class="flex justify-end pt-2 border-t border-gray-100">
                                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar Link" @click="registrarLink()" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border rounded-md">
                                <div class="p-4">
                                    <h2 class="text-center">Recursos del profesor para el estudiante</h2>
                                </div>
                                <table v-if="resources.length" class="table-responsive">
                                    <thead>
                                        <tr>
                                            <th class="xl:w-[250px]">Recurso Adjunto</th>
                                            <th>Descripción</th>
                                            <th>Tipo</th>
                                            <th class="xl:w-[200px]"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="resource in resources" :key="resource.id">
                                            <td data-label="Recurso Adjunto"> {{
                                                resource.name }}
                                            </td>
                                            <td data-label="Descripción"> {{
                                                resource.description }}
                                            </td>
                                            <td data-label="Tipo"> {{ resource.extension }}
                                            </td>
                                            <td class="flex justify-center">
                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                    <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                    <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                    <BaseButton color="success" :icon="mdiPresentation" @click="showVistaPrevia('/documents/' + resource.filepath + '/' + resource.filename, 'write', 'presentation')" class="hidden lg:grid" />
                                                    <BaseButton color="info" :icon="mdiEye" @click="showVistaPrevia('/documents/' + resource.filepath + '/' + resource.filename, 'write')" class="hidden lg:grid" />
                                                    <BaseButton color="info" :icon="mdiDownload" small :href="route('file-download2', { 'srctype': 'file_resource', 'srcid': resource.src_object_id, 'filename': resource.filename, 'srcid2': resource.origin_id2 })" target="_blank" />

                                                    <BaseButton v-if="canWrite" color="warning" :icon="mdiPencil" small @click="initModal(resource.id, 'actualizarFile', resource)" />
                                                    <BaseButton v-if="canWrite" color="danger" :icon="mdiTrashCan" small @click="initModal(resource.id, 'deleteFile')" />
                                                </BaseButtons>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- Links -->
                                <table v-if="resourceLinks.length" class="table-responsive">
                                    <thead>
                                        <tr>
                                            <th class="xl:w-[250px]">Recurso Link</th>
                                            <th>Descripción</th>
                                            <th>Link</th>
                                            <th class="xl:w-[200px]"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="resourceLink in resourceLinks" :key="resourceLink.id">
                                            <td data-label="Recurso Link"> {{
                                                resourceLink.label }}
                                            </td>
                                            <td data-label="Descripción">{{
                                                resourceLink.description }}
                                            </td>
                                            <td data-label="Tipo">
                                                <a class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" :href="resourceLink.url" title="Click para abrir Link" target="_blank">
                                                    Link</a>
                                            </td>
                                            <td class="flex justify-center">
                                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                    <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                    <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                    <BaseButton v-if="canWrite" color="warning" :icon="mdiPencil" small @click="initModal(resourceLink.id, 'actualizarLink', resourceLink)" />
                                                    <BaseButton v-if="canWrite" color="danger" :icon="mdiTrashCan" small @click="initModal(resourceLink.id, 'deleteLink')" />
                                                </BaseButtons>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="!resources.length && !resourceLinks.length" class="p-3">
                                    Sin recursos para el estudiante en este curso
                                </div>
                            </div>
                            <div class="border rounded-md" v-if="(isAdmin || isCoord || isMaster || isTutor)">
                                <div class="p-4">
                                    <h2 class="text-center">Recursos para el profesor</h2>
                                </div>
                                <div>
                                    <table v-if="guides.length" class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th class="xl:w-[250px]">Guía de estudio</th>
                                                <th>Descripción</th>
                                                <th class="xl:w-[200px]"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="guide in guides" :key="guide.id">
                                                <td data-label="Guía de estudio"> {{ guide.name
                                                }} </td>
                                                <td data-label="Descripción"> {{
                                                    guide.description }}
                                                </td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                        <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                        <!-- v-if="showPreviewGuide" <-- Se comenta esto pues a lso profesores se mostrará la guía de estudio -->
                                                        <BaseButton color="success" :icon="mdiPresentation" @click="showVistaPrevia('/documents/' + guide.filepath + '/' + guide.filename, 'onlyread', 'presentation')" class="hidden lg:grid" />
                                                        <BaseButton color="info" :icon="mdiEye" @click="showVistaPrevia('/documents/' + guide.filepath + '/' + guide.filename, 'onlyread')" class="hidden lg:grid" />
                                                        <!-- <BaseButton v-if="isAdmin || isCoord || isMaster || isTutor" color="info"
                                                                                :icon="mdiEye" small
                                                                                :href="route('pdf-viewer', { 'name': guide.name, 'ruta': '/documents/' + guide.filepath + '/' + guide.filename, 'print': (isCoord || isMaster ? false : true), 'download': (isCoord || isMaster ? false : true) })"
                                                                                target="_blank" /> -->
                                                        <!-- <BaseButton v-if="isAdmin" color="info"
                                                                                :icon="mdiDownload" small
                                                                                :href="route('file-download', { 'srctype': 'file_guideforcourse', 'srcid': (guide.src_object_id ? guide.src_object_id : 0), 'filename': guide.filename })"
                                                                                target="_blank" /> -->
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <table v-if="asesorias.length" class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th class="xl:w-[250px]">Asesoría</th>
                                                <th>Descripción</th>
                                                <th class="xl:w-[200px]"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in asesorias" :key="item.id">
                                                <td data-label="Asesoría"> {{ item.name
                                                }} </td>
                                                <td data-label="Descripción"> {{
                                                    item.description }}
                                                </td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                        <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                        <BaseButton color="success" :icon="mdiPresentation" @click="showVistaPrevia('/documents/' + item.filepath + '/' + item.filename, 'onlyread', 'presentation')" class="hidden lg:grid" />
                                                        <BaseButton color="info" :icon="mdiEye" @click="showVistaPrevia('/documents/' + item.filepath + '/' + item.filename, 'onlyread')" class="hidden lg:grid" />
                                                        <!-- <BaseButton v-if="isAdmin || isCoord || isMaster || isTutor" color="info"
                                                                                :icon="mdiEye" small
                                                                                :href="route('pdf-viewer', { 'name': guide.name, 'ruta': '/documents/' + guide.filepath + '/' + guide.filename, 'print': (isCoord || isMaster ? false : true), 'download': (isCoord || isMaster ? false : true) })"
                                                                                target="_blank" /> -->
                                                        <!-- <BaseButton v-if="isAdmin" color="info"
                                                                                :icon="mdiDownload" small
                                                                                :href="route('file-download', { 'srctype': 'file_guideforcourse', 'srcid': (guide.src_object_id ? guide.src_object_id : 0), 'filename': guide.filename })"
                                                                                target="_blank" /> -->
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <table v-if="motivaciones.length" class="table-responsive">
                                        <thead>
                                            <tr>
                                                <th class="xl:w-[250px]">Motivación</th>
                                                <th>Descripción</th>
                                                <th class="xl:w-[200px]"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in motivaciones" :key="item.id">
                                                <td data-label="Motivación"> {{ item.name
                                                }} </td>
                                                <td data-label="Descripción"> {{
                                                    item.description }}
                                                </td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                        <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                        <BaseButton color="success" :icon="mdiPresentation" @click="showVistaPrevia('/documents/' + item.filepath + '/' + item.filename, 'onlyread', 'presentation')" class="hidden lg:grid" />
                                                        <BaseButton color="info" :icon="mdiEye" @click="showVistaPrevia('/documents/' + item.filepath + '/' + item.filename, 'onlyread')" class="hidden lg:grid" />
                                                        <!-- <BaseButton v-if="isAdmin || isCoord || isMaster || isTutor" color="info"
                                                                                :icon="mdiEye" small
                                                                                :href="route('pdf-viewer', { 'name': guide.name, 'ruta': '/documents/' + guide.filepath + '/' + guide.filename, 'print': (isCoord || isMaster ? false : true), 'download': (isCoord || isMaster ? false : true) })"
                                                                                target="_blank" /> -->
                                                        <!-- <BaseButton v-if="isAdmin" color="info"
                                                                                :icon="mdiDownload" small
                                                                                :href="route('file-download', { 'srctype': 'file_guideforcourse', 'srcid': (guide.src_object_id ? guide.src_object_id : 0), 'filename': guide.filename })"
                                                                                target="_blank" /> -->
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="!guides.length && !asesorias.length && !motivaciones.length" class="p-3">
                                    Sin recursos para el profesor en este curso
                                </div>
                            </div>

                        </div>
                        <!-- Calificaciones -->
                        <div v-bind:class="{ 'hidden': openTab !== 6, 'block': openTab === 6 }">
                            <!-- Tabs y Acciones integrados -->
                            <div class="border-b">
                                <!-- Ayuda detalle -->

                                <div v-if="canWrite" class="flex-1 flex items-center justify-between gap-2 mb-2 h-[30px]">
                                    <div class="flex items-center gap-2 text-sm text-gray-600">
                                        <a v-if="arrayCalifications.length" href="#sectioncalificaciones" class="flex items-center gap-2 font-normal no-underline hover:underline text-blue-500  hover:text-red-500 duration-300" @click="showAyuda['calificaciones'] = !showAyuda['calificaciones']">
                                            <BaseIcon :path="mdiInformationOutline" size="20" />
                                            Ayuda Criterios de evaluación
                                        </a>
                                        <span v-else>
                                            <p class="text-sm font-normal flex items-center gap-2">
                                                <BaseIcon :path="mdiInformationOutline" size="20" /> Al iniciar las calif. todas se guardan con 8.
                                            </p>
                                        </span>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <BaseButton v-if="tabCalif !== -1 && !arrayCalifications.length" :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar calificaciones" @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + ['B1', 'B2', 'B3', 'B4'][tabCalif])" />
                                        <BaseButton v-else-if="tabCalif !== -1" :icon="mdiPlusCircle" color="info" icon-size="20" small label="Añadir calificaciones faltantes" @click.once="iniciarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + ['B1', 'B2', 'B3', 'B4'][tabCalif])" />


                                    </div>
                                </div>
                                <fieldset v-if="canWrite && arrayCalifications.length && showAyuda['calificaciones']" class="border border-gray-300 p-4 rounded-md mb-3">
                                    <legend class="text-lg font-bold px-2">Ayuda</legend>
                                    <ul class="text-sm space-y-1">
                                        <li>Puede guardar las calificaciones de un alumno con el botón guardar o ir al final para guardar todo si modifica varios registros.</li>
                                        <li>La cantidad y el número de orden puede variar si un alumno retirado fue calificado y otro ingresó al aula.</li>
                                        <li>Si falta un alumno en la lista, click en "Añadir calificaciones faltantes" para crear su registro.</li>
                                        <li>Puede pasar a la siguiente fila presionando TAB o ENTER, presione CTRL para pasar a la siguiente columna.</li>
                                    </ul>
                                </fieldset>
                            </div>
                            <div v-bind:class="{ 'hidden': openTab !== 6, 'block': openTab === 6 }">
                                <div class="flex flex-col lg:flex-row lg:w-auto w-full lg:justify-between items-center gap-3 py-3 mt-2 lg:mt-0">
                                    <div class="tab-interno" id="sectioncalificaciones">
                                        <button class="tab-interno-btn " @click="(tabCalif = 0), listarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1')" :class="[tabCalif == 0 ? 'active' : 'inactivo']">
                                            Primer bimestre
                                        </button>
                                        <button class="tab-interno-btn" @click="(tabCalif = 1), listarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2')" :class="[tabCalif == 1 ? 'active' : 'inactivo']">
                                            Segundo bimestre
                                        </button>
                                        <button class="tab-interno-btn" @click="(tabCalif = 2), listarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3')" :class="[tabCalif == 2 ? 'active' : 'inactivo']">
                                            Tercer bimestre
                                        </button>
                                        <button class="tab-interno-btn" @click="(tabCalif = 3), listarCalification(confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4')" :class="[tabCalif == 3 ? 'active' : 'inactivo']">
                                            Cuarto bimestre
                                        </button>
                                    </div>
                                    <div v-if="tabCalif !== -1 && arrayCalifications.length" class="flex items-center lg:justify-end justify-center gap-2 w-full lg:w-auto">
                                        <button v-if="confGlobal.value.CALIFICATION_EXPORT_VIEW_ENABLE == 1" @click="handleGradesExport('view')" class="w-9 h-9 rounded-full bg-gray-50 hover:bg-gray-100 border border-gray-200 flex items-center justify-center transition-colors shadow-sm" title="Descargar PDF">
                                            <i class="fa-solid fa-print text-[#1D4ED8] text-lg"></i>
                                        </button>
                                        <button v-if="confGlobal.value.CALIFICATION_EXPORT_PDF_ENABLE == 1" @click="handleGradesExport('pdf')" class="w-9 h-9 rounded-full bg-gray-50 hover:bg-gray-100 border border-gray-200 flex items-center justify-center transition-colors shadow-sm" title="Descargar PDF">
                                            <i class="fa-solid fa-file-pdf text-[#ab2121] text-lg"></i>
                                        </button>
                                        <button @click="handleGradesExport('xlsx')" class="w-9 h-9 rounded-full bg-gray-50 hover:bg-gray-100 border border-gray-200 flex items-center justify-center transition-colors shadow-sm" title="Descargar Excel">
                                            <i class="fa-solid fa-file-excel text-[#1c7847] text-lg"></i>
                                        </button>
                                    </div>
                                </div>
                                <!-- Tablas de Calificaciones por Bimestre -->
                                <template v-for="(bim, idx) in [
                                    { id: 'B1', close: closeB1, p2: confGlobal.value.EXAMEN_PARCIAL2_PRIMER_BIMESTRE == 1 },
                                    { id: 'B2', close: closeB2, p2: confGlobal.value.EXAMEN_PARCIAL2_SEGUNDO_BIMESTRE == 1 },
                                    { id: 'B3', close: closeB3, p2: confGlobal.value.EXAMEN_PARCIAL2_TERCER_BIMESTRE == 1 },
                                    { id: 'B4', close: closeB4, p2: confGlobal.value.EXAMEN_PARCIAL2_CUARTO_BIMESTRE == 1 }
                                ]" :key="bim.id">
                                    <div v-if="tabCalif == idx">
                                        <TableResponsive :headers="[
                                            { key: 'index', label: '#', style: 'width: 30px; min-width: 30px;' },
                                            { key: 'alumno', label: 'Alumno', standout: true },
                                            { key: 'type', label: 'Categoría', align: 'center', title: 'Estudiante nuevo N, antiguo A', rotate: true, style: 'width: 50px; min-width: 50px;' },
                                            { key: 'criterio1', label: trans?.criterio1 ? trans.criterio1 : 'Criterio 1', title: trans?.criterio1 ? trans.criterio1 : 'Criterio 1', class: 'text-center', condition: !!trans?.criterio1, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'criterio2', label: trans?.criterio2 ? trans.criterio2 : 'Criterio 2', title: trans?.criterio2 ? trans.criterio2 : 'Criterio 2', class: 'text-center', condition: !!trans?.criterio2, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'criterio3', label: trans?.criterio3 ? trans.criterio3 : 'Criterio 3', title: trans?.criterio3 ? trans.criterio3 : 'Criterio 3', class: 'text-center', condition: !!trans?.criterio3, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'criterio4', label: trans?.criterio4 ? trans.criterio4 : 'Criterio 4', title: trans?.criterio4 ? trans.criterio4 : 'Criterio 4', class: 'text-center', condition: !!trans?.criterio4, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'criterio5', label: trans?.criterio5 ? trans.criterio5 : 'Criterio 5', title: trans?.criterio5 ? trans.criterio5 : 'Criterio 5', class: 'text-center', condition: !!trans?.criterio5, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'criterio6', label: trans?.criterio6 ? trans.criterio6 : 'Criterio 6', title: trans?.criterio6 ? trans.criterio6 : 'Criterio 6', class: 'text-center', condition: !!trans?.criterio6, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'examen_parcial', label: 'Ex. parcial', title: 'Examen parcial', class: 'text-center', rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'examen_parcial2', label: 'Ex. parcial2', title: 'Examen parcial2', class: 'text-center', condition: bim.p2, rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'examen_final', label: 'Ex. final', title: 'Examen final', class: 'text-center', rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'promedio', label: 'Promedio', title: 'Promedio', class: 'text-center font-bold bg-blue-50 text-blue-900 border-l border-r border-blue-100', cellClass: 'bg-blue-50/30 border-l border-r border-blue-100 lg:bg-blue-50/30', rotate: true, style: 'width: 70px; min-width: 70px;' },
                                            { key: 'actions', label: '', title: 'Actions', class: 'text-center', condition: canWrite },
                                            { key: 'log', label: 'Log', title: 'Log' }
                                        ]" :items="arrayCalifications">
                                            <template #empty>
                                                <template v-if="tabCalif === -1">
                                                    Haga clic en un bimestre para cargar el listado ⤴
                                                </template>
                                                <template v-else-if="!canWrite">
                                                    No se han iniciado calificaciones de este bimestre.
                                                </template>
                                                <template v-else>
                                                    Click en &quot;Iniciar calificaciones&quot; para comenzar ⤴ <br> <span class="text-xs text-gray-400">O seleccione otro bimestre</span>
                                                </template>
                                            </template>
                                            <template #cell-index="{ item: cal, index }">
                                                <span :set="indexcol = 0">{{ index + 1 }}</span>
                                                <!-- Num valores divisor de promedio -->
                                                <input type="hidden" :set="numval = 0">
                                                <!-- Suma valores -->
                                                <input type="hidden" :set="sumval = 0">
                                            </template>

                                            <template #cell-alumno="{ item: cal }">
                                                <span class="bg-gray-100 lg:bg-transparent" :set="indexcol++">
                                                    {{ cal.apellidos + ' ' + cal.nombres }}
                                                </span>
                                            </template>

                                            <template #cell-type="{ item: cal, index }">
                                                <div>{{ cal.type ? 'A' : 'N' }}</div>
                                            </template>

                                            <template #cell-criterio1="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.criterio1) }} -->
                                                <input type="hidden" :set="numval = numval + 1">
                                                <span v-if="!canWrite || bim.close">{{ cal.criterio1 }}</span>
                                                <input v-else v-model="cal.criterio1" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio1) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio1 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio1)">
                                                <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio1)">
                                            </template>

                                            <template #cell-criterio2="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.criterio2) }} -->
                                                <input type="hidden" :set="numval = numval + 1">
                                                <span v-if="!canWrite || bim.close">{{ cal.criterio2 }}</span>
                                                <input v-else v-model="cal.criterio2" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio2) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio2 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio2)">
                                                <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio2)">
                                            </template>

                                            <template #cell-criterio3="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.criterio3) }} -->
                                                <input type="hidden" :set="numval = numval + 1">
                                                <span v-if="!canWrite || bim.close">{{ cal.criterio3 }}</span>
                                                <input v-else v-model="cal.criterio3" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio3) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio3 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio3)">
                                                <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio3)">
                                            </template>

                                            <template #cell-criterio4="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.criterio4) }} -->
                                                <input type="hidden" :set="numval = numval + 1">
                                                <span v-if="!canWrite || bim.close">{{ cal.criterio4 }}</span>
                                                <input v-else v-model="cal.criterio4" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio4) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio4 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio4)">
                                                <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio4)">
                                            </template>

                                            <template #cell-criterio5="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.criterio5) }} -->
                                                <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_CRITERIO5_PESO ?? 1)">
                                                <input type="hidden" :set="cal.criterio5_peso = (confGlobal.value.CALIFICATION_CRITERIO5_PESO ?? 1)">
                                                <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio5_peso">{{ cal.criterio5 }}</span>
                                                <input v-else v-model="cal.criterio5" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio5_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio5) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio5 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio5)">
                                                <input type="hidden" :set="sumval = sumval + parseFloat(cal.criterio5 * cal.criterio5_peso)">
                                                <input type="hidden" v-model="cal.criterio5_peso">
                                            </template>

                                            <template #cell-criterio6="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.criterio6) }} -->
                                                <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_CRITERIO6_PESO ?? 1)">
                                                <input type="hidden" :set="cal.criterio6_peso = (confGlobal.value.CALIFICATION_CRITERIO6_PESO ?? 1)">
                                                <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio6_peso">{{ cal.criterio6 }}</span>
                                                <input v-else v-model="cal.criterio6" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio6_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio6) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio6 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio6)">
                                                <input type="hidden" :set="sumval = sumval + parseFloat(cal.criterio6 * cal.criterio6_peso)">
                                                <input type="hidden" v-model="cal.criterio6_peso">
                                            </template>

                                            <template #cell-examen_parcial="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.examen_parcial) }} -->
                                                <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_EXAMEN_PARCIAL_PESO ?? 1)">
                                                <input type="hidden" :set="cal.examen_parcial_peso = (confGlobal.value.CALIFICATION_EXAMEN_PARCIAL_PESO ?? 1)">
                                                <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial_peso">{{ cal.examen_parcial }}</span>
                                                <input v-else v-model="cal.examen_parcial" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.examen_parcial) ? 'bg-red-600 border-red-600 text-white' : (cal.examen_parcial < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.examen_parcial)">
                                                <input type="hidden" :set="sumval = sumval + parseFloat(cal.examen_parcial * cal.examen_parcial_peso)">
                                                <input type="hidden" v-model="cal.examen_parcial_peso">
                                            </template>

                                            <template #cell-examen_parcial2="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.examen_parcial2) }} -->
                                                <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_EXAMEN_PARCIAL2_PESO ?? 1)">
                                                <input type="hidden" :set="cal.examen_parcial2_peso = (confGlobal.value.CALIFICATION_EXAMEN_PARCIAL2_PESO ?? 1)">
                                                <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial2_peso">{{ cal.examen_parcial2 }}</span>
                                                <input v-else v-model="cal.examen_parcial2" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial2_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.examen_parcial2) ? 'bg-red-600 border-red-600 text-white' : (cal.examen_parcial2 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.examen_parcial2)">
                                                <input type="hidden" :set="sumval = sumval + parseFloat(cal.examen_parcial2 * cal.examen_parcial2_peso)">
                                                <input type="hidden" v-model="cal.examen_parcial2_peso">
                                            </template>

                                            <template #cell-examen_final="{ item: cal, index }">
                                                <!-- {{ formatNotaOut(cal.examen_final) }} -->
                                                <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_EXAMEN_FINAL_PESO ?? 1)">
                                                <input type="hidden" :set="cal.examen_final_peso = (confGlobal.value.CALIFICATION_EXAMEN_FINAL_PESO ?? 1)">
                                                <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_final_peso">{{ cal.examen_final }}</span>
                                                <input v-else v-model="cal.examen_final" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_final_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.examen_final) ? 'bg-red-600 border-red-600 text-white' : (cal.examen_final < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.examen_final)">
                                                <input type="hidden" :set="sumval = sumval + parseFloat(cal.examen_final * cal.examen_final_peso)">
                                                <input type="hidden" v-model="cal.examen_final_peso">
                                            </template>

                                            <template #cell-promedio="{ item: cal }">
                                                <div class="text-center items-center font-bold text-base" :class="(cal.promedio < 11 ? 'text-red-600' : 'text-blue-900')" :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((sumval) / numval).toFixed(2)))" :title="sumval + '/' + numval + ' = ' + promedio_decimal + ' = ' + cal.promedio_text">
                                                    <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                    <span v-if="!canWrite || bim.close">{{ cal.promedio }}</span>
                                                    <input v-else v-model="cal.promedio" class="inline-block input-small text-center w-20 lg:w-full font-bold text-base" :class="(cal.promedio < 11 ? 'text-red-600' : 'text-blue-900')" :disabled="hasInvalidGrades && !isNotaInvalida(cal.promedio)">
                                                    <input type="hidden" v-model="cal.promedio_text">
                                                </div>
                                            </template>

                                            <template #cell-actions="{ item: cal }">
                                                <BaseButtons type="justify-center space-x-3 lg:justify-end" no-wrap>
                                                    <BaseButton :name="'buttonssave' + bim.id" color="info" :icon="mdiContentSave" small @click="updateCalification(cal.id, 'actualizar', cal)" :disabled="hasInvalidGrades" />
                                                </BaseButtons>
                                            </template>

                                            <template #cell-log="{ item: cal }">
                                                <div @click="showLog = !showLog">
                                                    <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                    <span class="text-xs" v-if="showLog">Modif. {{ cal.nombre_usuario }} {{ cal.updated_at ? formatDateTime(cal.updated_at) : '' }}</span>
                                                </div>
                                            </template>
                                        </TableResponsive>
                                        <div class="pt-3 w-full flex justify-center" v-if="arrayCalifications.length && canWrite && !bim.close">
                                            <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayCalifications(bim.id)" :disabled="hasInvalidGrades" />
                                        </div>
                                    </div>
                                </template>

                                <div v-if="tabCalif == -1" class="mt-4">
                                    Click al bimestre para mostrar el listado ⤴
                                </div>
                            </div>
                    </div>
                    <div v-bind:class="{ 'hidden': openTab !== 7, 'block': openTab === 7 }">
                        <!-- Anuncios -->
                        <div class="bg-white rounded-xl shadow-sm p-4 border">
                        <div class="flex justify-between">
                            <div class="flex items-center mb-3">
                                <div class="h-8 w-8 mr-3">
                                    <BaseIcon :path="mdiAccountVoice" :size="36" class="h-8 w-8 text-green-600" />
                                </div>
                                <div class="inline-block">
                                    <h1 class="text-gray-900 text-base xl:text-xl font-semibold">Anuncios
                                    </h1>
                                </div>
                            </div>
                            <div>
                                <BaseIcon :path="mdiPlus" :size="24" class="text-gray-800 w-6 h-6" @click="initCreateAnuncio()" />
                            </div>
                        </div>
                    <div class="overflow-y-auto h-auto max-h-[400px] grid gap-2">
                        <div class="flex flex-col gap-1">
                            <div v-show="createAnuncio" class="text-sm grid grid-cols-1 gap-2">
                                <span v-if="errorAnuncio" v-text="errorAnuncio" class="text-red-500"></span>
                                <div class="col-span-1">
                                    <textarea ref="anuncio_label" value="" class="w-full h-[108px] xl:h-[186px] focus:!ring-0" v-model="formAnuncio.label" />
                                    <BaseButton color="info" :icon="mdiContentSave" small label="Publicar anuncio" @click="anuncioUpdateOrCreate()" />
                                </div>
                                <!-- <div class="flex justify-between items-center gap-2 w-full">
                                                    
                                                    <div class="flex flex-col lg:flex-row gap-2">
                                                        
                                                        <div class="inline-block">
                                                            Inicio: <input type="date">
                                                        </div>
                                                        <div class="inline-block">
                                                            Fin: <input type="date">
                                                        </div>
                                                    </div>
                                                    <div class="flex items-end lg:items-center h-full">

                                                        <BaseButton color="info" :icon="mdiContentSave" small
                                                            @click="anuncioUpdateOrCreate()" />
                                                    </div>
                                                </div> -->


                            </div>
                            <template v-if="anuncios.length">
                                <div v-for="anuncio in anuncios" :key="anuncio.id" class="flex justify-between border p-1 pl-2" :class="anuncio.status == 1 ? 'border-green-300 bg-green-50 rounded-md text-green-600' : 'border-gray-200 bg-gray-100 rounded-md'">
                                    <div class="flex items-center text-xs xl:text-sm">
                                        <p class="pr-2">{{ anuncio.label }}</p>
                                    </div>
                                    <div class="grid grid-flow-col auto-cols-max gap-1">
                                        <div v-if="anuncio.status == 1" title="Nuevo Anuncio - Click para cambiar a pasado">
                                            <BaseButton color="success" :icon="mdiNewBox" small @click="anuncioUpdateOrCreate(anuncio.id, 'desactivar')" class="!p-0" />
                                        </div>
                                        <div v-if="anuncio.status == 0" title="Anuncio pasado - Click para resaltar">
                                            <BaseButton color="contrast" :icon="mdiNewspaper" small @click="anuncioUpdateOrCreate(anuncio.id, 'activar')" class="!p-0" />
                                        </div>
                                        <div v-if="anuncio.status == 0" title="Eliminar Anuncio">
                                            <BaseButton color="danger" :icon="mdiTrashCan" small @click="anuncioUpdateOrCreate(anuncio.id, 'eliminar')" class="!p-0" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                            </div>
                        </div>
                    </div>
                    </div> <!-- End of Tab 7 -->

                        </div>
                    </div>
                </div>
        </div> <!-- End of main tabs container -->

        <CardBoxModal v-model="isPostitActive" title="Nota Privada del Docente" button="info" buttonLabel="Guardar" @confirm="updateOrCreatePostit(postit.id, postit.description); isPostitActive = false" hasCancel>
            <div class="h-[200px]">
                <textarea ref="nota_privada_label" class="resize-none block h-full w-full text-sm text-gray-900 border rounded-md bg-amber-100 p-4" v-model="postit.description" placeholder="Escribe aquí tu nota privada... (Solo visible para ti)" autofocus></textarea>
                <div class="text-xs text-green-600 mt-2">{{ alertPostit }}</div>
            </div>
        </CardBoxModal>
        <ModalAlert v-bind="modalAlertState" @close="modalAlertState.show = false" />
    </BreezeAuthenticatedLayout>
</template>
<style scoped>
#right-click-menu {
    background: #FAFAFA;
    border: 1px solid #BDBDBD;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 250px;
    z-index: 999999;
}

#right-click-menu li {
    border-bottom: 1px solid #E0E0E0;
    margin: 0;
    padding: 5px 35px;
}

#right-click-menu li:last-child {
    border-bottom: none;
}

#right-click-menu li:hover {
    background: #1E88E5;
    color: #FAFAFA;
}

/** Vista previa de pdf no descargar, no funciona aun */
/* embed #downloads {
        display: none;
    } */

embed #downloads {
    @apply hidden;
}
</style>